const navigation = {
  'navigation.section.collect': 'Collect',
  'navigation.section.process': 'Process',
  'navigation.section.create': 'Create',
  'navigation.section.short_drama': 'Short Drama',
  'navigation.section.ai_employees': 'AI Employees',
  'navigation.section.capabilities': 'Capabilities',
  'navigation.section.manage': 'Manage',
  'navigation.item.sources': 'Sources',
  'navigation.item.materials': 'Materials',
  'navigation.item.desktop_materials': 'Local Materials',
  'navigation.item.notebooks': 'Notebooks',
  'navigation.item.search': 'Ask and Search',
  'navigation.item.ecommerce': 'E-commerce Product',
  'navigation.item.midjourney_v7': 'MidJourney V7',

  'navigation.item.bananapro': 'Nano Banana Pro',
  'navigation.item.video_generator': 'Video Generator',
  'navigation.item.comfyui_workflow': 'ComfyUI Workflow',
  'navigation.item.short_drama_projects': 'Short Drama Project Library',
  'navigation.item.short_drama_assets': 'Short Drama Asset Library',
  'navigation.item.short_drama_prompts': 'Prompt Templates',
  'navigation.item.creation_prompts': 'Prompt Templates',
  'navigation.item.digital_employees': 'Mobile Employees',
  'navigation.item.browser_employees': 'Browser Employees',
  'navigation.item.agents': 'Agent',
  'navigation.item.plugins': 'Plugins',
  'navigation.item.pc_employees': 'PC Employees',
  'navigation.item.projects': 'Projects',
  'navigation.item.marketplace': 'App Store',
  'navigation.item.fishown': 'FishOwn',
  'navigation.item.skills': 'Plugins & Skills',
  'navigation.item.workflows': 'Workflows',
  'navigation.item.cron': 'Cron',
  'navigation.item.models': 'Models',
  'navigation.item.organization': 'Organization',
    'navigation.item.settings': 'Settings',
  'navigation.item.advanced': 'Advanced',
  'navigation.item.task_monitor': 'Task Monitor',
  'navigation.item.member_center': 'Member Center',
  'navigation.create': 'Create',
  'navigation.create.digital_employees': 'Mobile Employees',
  'navigation.create.source': 'Source',
  'navigation.create.notebook': 'Notebook',
  'navigation.create.image_generator': 'Image Generator',
  'navigation.create.tooltip': 'Create',
  'navigation.backToNotebook': 'Back to Notebook',
  'navigation.backToSources': 'Back to Sources',
}

const controls = {
  'controls.theme': 'Theme',
  'controls.quickActions': 'Quick actions',
  'controls.quickActionsHint': 'Navigation, search, ask, theme',
  'controls.signOut': 'Sign Out',
}

const user = {
  'user.menuTitle': 'User',
  'user.systemLabel': 'System',
  'user.systemTooltip': 'Tenant: {system}',
  'user.systemUnknown': 'Unknown system',
  'user.tenantUnknown': 'Unknown tenant',
  'user.spaceUnknown': 'Unknown space',
  'user.spaceLabel': 'Space',
  'user.switchTenant': 'Switch Tenant',
  'user.roleLabel': 'Role',
  'user.role.owner': 'Owner',
  'user.role.admin': 'Admin',
  'user.role.employee': 'Employee',
  'user.role.unknown': 'Unknown role',
}

const settingsLanguage = {
  'settings.title': 'Settings',
  'settings.language.title': 'Interface language',
  'settings.language.description': 'Choose the language for the dashboard',
  'settings.language.note': 'Changes apply immediately to navigation and UI controls.',
  'settings.language.en': 'English',
  'settings.language.zh': '中文',
}

const settingsActions = {
  'settings.actions.save': 'Save Settings',
  'settings.actions.saving': 'Saving...',
}

const settingsCommon = {
  'settings.common.helpMeChoose': 'Help me choose',
  'settings.load.errorTitle': 'Failed to load settings',
  'settings.load.errorUnexpected': 'An unexpected error occurred.',
  'common.all': 'All',
}

const settingsContentProcessing = {
  'settings.content.title': 'Content Processing',
  'settings.content.description': 'Configure how documents and URLs are processed',
  'settings.content.doc.label': 'Document Processing Engine',
  'settings.content.doc.placeholder': 'Select document processing engine',
  'settings.content.doc.option.auto': 'Auto (Recommended)',
  'settings.content.doc.option.docling': 'Docling',
  'settings.content.doc.option.simple': 'Simple',
  'settings.content.doc.help.docling':
    'Docling is a little slower but more accurate, especially if the documents contain tables and images.',
  'settings.content.doc.help.simple':
    "Simple will extract any content from the document without formatting it. It's ok for simple documents, but will lose quality in complex ones.",
  'settings.content.doc.help.auto':
    'Auto (recommended) will try to process through Docling and default to Simple.',
  'settings.content.url.label': 'URL Processing Engine',
  'settings.content.url.placeholder': 'Select URL processing engine',
  'settings.content.url.option.auto': 'Auto (Recommended)',
  'settings.content.url.option.firecrawl': 'Firecrawl',
  'settings.content.url.option.jina': 'Jina',
  'settings.content.url.option.simple': 'Simple',
  'settings.content.url.help.firecrawl':
    'Firecrawl is a paid service (with a free tier) and very powerful.',
  'settings.content.url.help.jina': 'Jina is a good option as well and also has a free tier.',
  'settings.content.url.help.simple':
    'Simple will use basic HTTP extraction and will miss content on JavaScript-based websites.',
  'settings.content.url.help.auto':
    'Auto (recommended) will try to use Firecrawl (if API Key is present). Then, it will use Jina until it reaches the limit (or will keep using Jina if you set up the API Key). It will fall back to Simple when none of the previous options is possible.',
}

const settingsEmbedding = {
  'settings.embedding.title': 'Embedding and Search',
  'settings.embedding.description': 'Configure search and embedding options',
  'settings.embedding.label': 'Default Embedding Option',
  'settings.embedding.placeholder': 'Select embedding option',
  'settings.embedding.option.ask': 'Ask',
  'settings.embedding.option.always': 'Always',
  'settings.embedding.option.never': 'Never',
  'settings.embedding.help.intro':
    "Embedding the content will make it easier to find by you and by your AI agents. If you are running a local embedding model (Ollama, for example), you shouldn't worry about cost and just embed everything. For online providers, you might want to be careful only if you process a lot of content (like 100s of documents at a day).",
  'settings.embedding.help.always':
    'Choose always if you are running a local embedding model or if your content volume is not that big.',
  'settings.embedding.help.ask': 'Choose ask if you want to decide every time.',
  'settings.embedding.help.never':
    "Choose never if you don't care about vector search or do not have an embedding provider.",
  'settings.embedding.help.cost':
    "As a reference, OpenAI's text-embedding-3-small costs about 0.02 for 1 million tokens -- which is about 30 times the Wikipedia page for Earth. With Gemini API, Text Embedding 004 is free with a rate limit of 1500 requests per minute.",
}

const settingsFiles = {
  'settings.files.title': 'File Management',
  'settings.files.description': 'Configure file handling and storage options',
  'settings.files.label': 'Auto Delete Files',
  'settings.files.placeholder': 'Select auto delete option',
  'settings.files.option.yes': 'Yes',
  'settings.files.option.no': 'No',
  'settings.files.help.intro':
    'Once your files are uploaded and processed, they are not required anymore. Most users should allow FishOwn Agent to delete uploaded files from the upload folder automatically. Choose no ONLY if you are using Notebook as the primary storage location for those files (which you should not be at all). This option will soon be deprecated in favor of always downloading the files.',
  'settings.files.help.yes':
    'Choose yes (recommended) to automatically delete uploaded files after processing.',
  'settings.files.help.no': 'Choose no only if you need to keep the original files in the upload folder.',
}

const notebooksPage = {
  'notebooks.page.title': 'Notebooks',
  'notebooks.page.searchPlaceholder': 'Search notebooks...',
  'notebooks.page.create': 'New Notebook',
  'notebooks.page.activeTitle': 'Active Notebooks',
  'notebooks.page.archivedTitle': 'Archived Notebooks',
  'notebooks.page.empty.searchActiveTitle': 'No notebooks match your search',
  'notebooks.page.empty.searchActiveDescription': 'Try using a different notebook name.',
  'notebooks.page.empty.searchArchivedTitle': 'No archived notebooks match your search',
  'notebooks.page.empty.searchArchivedDescription': 'Modify your search to find archived notebooks.',
}

const notebooksList = {
  'notebooks.list.empty.title': 'No notebooks yet',
  'notebooks.list.empty.description': 'Start by creating your first notebook to organize your research.',
}

const notebooksCard = {
  'notebooks.card.archived': 'Archived',
  'notebooks.card.unarchive': 'Unarchive',
  'notebooks.card.archive': 'Archive',
  'notebooks.card.delete': 'Delete',
  'notebooks.card.noDescription': 'No description',
  'notebooks.card.updated': 'Updated',
  'notebooks.card.confirm.title': 'Delete Notebook',
  'notebooks.card.confirm.description':
    'Are you sure you want to delete "{name}"? This action cannot be undone and will delete all sources, notes, and chat sessions.',
  'notebooks.card.confirm.cta': 'Delete',
}

const notebooksHeader = {
  'notebooks.header.namePlaceholder': 'Notebook name',
  'notebooks.header.archivedBadge': 'Archived',
  'notebooks.header.unarchive': 'Unarchive',
  'notebooks.header.archive': 'Archive',
  'notebooks.header.knowledgeGraph': 'Knowledge Graph',
  'notebooks.header.knowledgeGraphComingSoon': 'Not available yet. Stay tuned.',
  'notebooks.header.delete': 'Delete',
  'notebooks.header.descriptionPlaceholder': 'Add a description...',
  'notebooks.header.descriptionEmpty': 'Add a description...',
  'notebooks.header.meta.created': 'Created',
  'notebooks.header.meta.updated': 'Updated',
  'notebooks.header.confirm.title': 'Delete Notebook',
  'notebooks.header.confirm.description':
    'Are you sure you want to delete "{name}"? This action cannot be undone and will delete all sources, notes, and chat sessions.',
  'notebooks.header.confirm.cta': 'Delete Forever',
}

const notebooksDetail = {
  'notebooks.detail.notFoundTitle': 'Notebook Not Found',
  'notebooks.detail.notFoundDescription': 'The requested notebook could not be found.',
  'notebooks.detail.tabs.sources': 'Sources',
  'notebooks.detail.tabs.notes': 'Notes',
  'notebooks.detail.tabs.chat': 'Chat',
}

const notebooksKnowledgeGraph = {
  'notebooks.knowledgeGraph.title': 'Knowledge Graph',
  'notebooks.knowledgeGraph.description': 'Knowledge graph for notebook {notebookId}.',

  'notebooks.knowledgeGraph.status.initializing': 'Initializing...',
  'notebooks.knowledgeGraph.status.checkingIndex': 'Checking for indexed data...',
  'notebooks.knowledgeGraph.status.loadingWindow': 'Loading graph window...',
  'notebooks.knowledgeGraph.status.loadingJson': 'Loading JSON data files...',
  'notebooks.knowledgeGraph.status.processingGraph': 'Processing graph structure...',
  'notebooks.knowledgeGraph.status.rendering': 'Rendering visualization...',
  'notebooks.knowledgeGraph.status.noGraph': 'No graph loaded',
  'notebooks.knowledgeGraph.status.reloadingGraph': 'Reloading graph data...',
  'notebooks.knowledgeGraph.status.graphReloaded': 'Graph reloaded',
  'notebooks.knowledgeGraph.status.rebuilding': 'Rebuilding knowledge graph...',
  'notebooks.knowledgeGraph.status.rebuildFailed': 'Rebuild failed',

  'notebooks.knowledgeGraph.error.missingNotebookId': 'Missing notebook id',
  'notebooks.knowledgeGraph.error.loadFailed': 'Failed to load graph data',
  'notebooks.knowledgeGraph.error.reloadFailed': 'Failed to reload graph data',
  'notebooks.knowledgeGraph.error.rebuildFailed': 'Failed to rebuild knowledge graph',

  'notebooks.knowledgeGraph.tab.corpus': 'Corpus',
  'notebooks.knowledgeGraph.tab.explore': 'Explore',
  'notebooks.knowledgeGraph.tab.chat': 'Chat',
  'notebooks.knowledgeGraph.tab.groups': 'Groups',
  'notebooks.knowledgeGraph.tab.inspector': 'Inspector',

  'notebooks.knowledgeGraph.explore.title': 'Graph Explorer',
  'notebooks.knowledgeGraph.explore.description': 'Search, filter, and jump across the current knowledge graph',
  'notebooks.knowledgeGraph.explore.stat.entities': 'Entities',
  'notebooks.knowledgeGraph.explore.stat.relationships': 'Relationships',
  'notebooks.knowledgeGraph.explore.stat.communities': 'Communities',
  'notebooks.knowledgeGraph.explore.stat.textUnits': 'Text units',
  'notebooks.knowledgeGraph.explore.query.title': 'Query',
  'notebooks.knowledgeGraph.explore.query.placeholder': 'Search entities, descriptions, modalities...',
  'notebooks.knowledgeGraph.explore.query.querying': 'Server query running...',
  'notebooks.knowledgeGraph.explore.query.resultsHint': '{local} local matches · {server} server matches',
  'notebooks.knowledgeGraph.explore.query.noResults': 'No matching nodes.',
  'notebooks.knowledgeGraph.explore.filters.title': 'Filters',
  'notebooks.knowledgeGraph.explore.filters.modality': 'Modality',
  'notebooks.knowledgeGraph.explore.filters.entityType': 'Entity type',
  'notebooks.knowledgeGraph.explore.filters.clear': 'Clear filters',
  'notebooks.knowledgeGraph.explore.topEntities': 'Top Entities',
  'notebooks.knowledgeGraph.explore.topEntitiesLinkCount': '{count} links',
  'notebooks.knowledgeGraph.explore.topRelationships': 'Strong Relationships',
  'notebooks.knowledgeGraph.explore.topCommunities': 'Largest Communities',
  'notebooks.knowledgeGraph.explore.communityFallback': 'Community {id}',
  'notebooks.knowledgeGraph.explore.communityInfo': 'Level {level} · {size} entities',
  'notebooks.knowledgeGraph.explore.nodeInfo': '{type} · {modality} · {degree} links',
  'notebooks.knowledgeGraph.explore.linkInfo': 'weight {weight} · {description}',

  'notebooks.knowledgeGraph.communities.title': 'Communities',
  'notebooks.knowledgeGraph.communities.description': '{count} communities from the current graph',
  'notebooks.knowledgeGraph.communities.empty': 'No communities available. Run the graph index first.',
  'notebooks.knowledgeGraph.communities.communityWithRelInfo': 'Level {level} · {size} entities · {rels} relationships',

  'notebooks.knowledgeGraph.renderer.3d': '3D',
  'notebooks.knowledgeGraph.renderer.large': 'Large',
  'notebooks.knowledgeGraph.renderer.3dHint': 'Detailed 3D renderer',
  'notebooks.knowledgeGraph.renderer.largeHint': 'Instanced WebGL renderer for larger graphs',

  'notebooks.knowledgeGraph.topbar.searchPlaceholder': 'Search entities...',
  'notebooks.knowledgeGraph.topbar.clearSearch': 'Clear search',
  'notebooks.knowledgeGraph.topbar.graphQuery': 'Graph Query',
  'notebooks.knowledgeGraph.topbar.querying': 'querying...',
  'notebooks.knowledgeGraph.topbar.queryResults': '{shown} shown · {server} server',
  'notebooks.knowledgeGraph.topbar.noResults': 'No matching graph nodes.',
  'notebooks.knowledgeGraph.topbar.communityIsolator': 'Community Isolator',

  'notebooks.knowledgeGraph.corpus.title': 'Corpus',
  'notebooks.knowledgeGraph.corpus.description': 'GraphRAG index management',
  'notebooks.knowledgeGraph.corpus.loadedKg': 'Loaded KG:',
  'notebooks.knowledgeGraph.corpus.noKg': '(none)',
  'notebooks.knowledgeGraph.corpus.rename': 'Rename',
  'notebooks.knowledgeGraph.corpus.runIndex': 'Run Index',
  'notebooks.knowledgeGraph.corpus.stop': 'Stop',
  'notebooks.knowledgeGraph.corpus.forceReindex': 'Force reindex',
  'notebooks.knowledgeGraph.corpus.indexed': 'Indexed',
  'notebooks.knowledgeGraph.corpus.noIndexPresent': 'No index present',
  'notebooks.knowledgeGraph.corpus.indexedOverview': 'Indexed Overview',
  'notebooks.knowledgeGraph.corpus.lastIndexed': 'Last indexed: {time}',
  'notebooks.knowledgeGraph.corpus.neverIndexed': 'Never indexed',
  'notebooks.knowledgeGraph.corpus.noIndexHint': 'No index found. Add files in the Sources panel on the left, then click "Run Index" to build the knowledge graph.',
  'notebooks.knowledgeGraph.corpus.dataset': 'Dataset',
  'notebooks.knowledgeGraph.corpus.sourceHint': 'Sources (from notebook sources)',
  'notebooks.knowledgeGraph.corpus.noSources': 'No sources yet. Add files in the Sources panel on the left.',
  'notebooks.knowledgeGraph.corpus.archives': 'Archives',
  'notebooks.knowledgeGraph.corpus.archiveCurrent': 'Archive current',
  'notebooks.knowledgeGraph.corpus.noArchives': 'No archives',
  'notebooks.knowledgeGraph.corpus.restore': 'Restore',
  'notebooks.knowledgeGraph.corpus.delete': 'Delete',
  'notebooks.knowledgeGraph.corpus.jsonFile': 'JSON File',
  'notebooks.knowledgeGraph.corpus.import': 'Import',
  'notebooks.knowledgeGraph.corpus.pasteContentList': 'Paste content_list JSON',
  'notebooks.knowledgeGraph.corpus.assetBaseDir': 'Asset base dir for relative image paths',
  'notebooks.knowledgeGraph.corpus.noJsonSelected': 'No JSON selected',
  'notebooks.knowledgeGraph.corpus.terminalLogs': 'Terminal Logs',
  'notebooks.knowledgeGraph.corpus.noLogs': 'No logs yet.',
  'notebooks.knowledgeGraph.corpus.table.file': 'File',
  'notebooks.knowledgeGraph.corpus.table.size': 'Size',
  'notebooks.knowledgeGraph.corpus.table.status': 'Status',
  'notebooks.knowledgeGraph.corpus.table.noResults': 'No results.',
  'notebooks.knowledgeGraph.corpus.retry': 'Retry',
  'notebooks.knowledgeGraph.corpus.retryPipeline': 'Pipeline',
  'notebooks.knowledgeGraph.corpus.retryVector': 'Vector',
  'notebooks.knowledgeGraph.corpus.retryGraph': 'Graph',
  'notebooks.knowledgeGraph.corpus.retryCommunity': 'Community',
  'notebooks.knowledgeGraph.corpus.status.indexed': 'indexed',
  'notebooks.knowledgeGraph.corpus.status.vectorizing': 'vectorizing',
  'notebooks.knowledgeGraph.corpus.status.scanning': 'scanning',
  'notebooks.knowledgeGraph.corpus.status.communities': 'communities',
  'notebooks.knowledgeGraph.corpus.status.error': 'error',
  'notebooks.knowledgeGraph.corpus.status.removed': 'removed',
  'notebooks.knowledgeGraph.corpus.status.requiresIndexing': 'requires indexing',
  'notebooks.knowledgeGraph.corpus.stage.vector': 'Vector',
  'notebooks.knowledgeGraph.corpus.stage.graph': 'Graph',
  'notebooks.knowledgeGraph.corpus.stage.community': 'Community',
  'notebooks.knowledgeGraph.corpus.stage.failed': '{count} failed',
  'notebooks.knowledgeGraph.visualizer.errorTitle': 'Failed to Load Graph Data',
  'notebooks.knowledgeGraph.visualizer.retryLoading': 'Retry Loading',
  'notebooks.knowledgeGraph.visualizer.rebuilding': 'Rebuilding...',
  'notebooks.knowledgeGraph.visualizer.rebuildGraph': 'Rebuild Graph',
  'notebooks.knowledgeGraph.visualizer.loadingTitle': 'Loading Knowledge Graph',
  'notebooks.knowledgeGraph.visualizer.pctComplete': '{pct}% complete',
  'notebooks.knowledgeGraph.visualizer.noKbTitle': 'No Knowledge Base Available',
  'notebooks.knowledgeGraph.visualizer.noKbDesc': 'Please upload documents and index them to create a knowledge graph visualization.',
  'notebooks.knowledgeGraph.visualizer.noKbStart': 'To get started:',
  'notebooks.knowledgeGraph.visualizer.noKbStep1': '1. Upload PDFs to the input/ directory',
  'notebooks.knowledgeGraph.visualizer.noKbStep2': '2. Run the GraphRAG indexing process',
  'notebooks.knowledgeGraph.visualizer.noKbStep3': '3. Return here to visualize your graph',
  'notebooks.knowledgeGraph.visualizer.largeView': 'Large Graph View',
  'notebooks.knowledgeGraph.visualizer.3dView': '3D Graph View',
  'notebooks.knowledgeGraph.visualizer.nodeEdgeStats': '{nodes} nodes · {edges} edges',
  'notebooks.knowledgeGraph.visualizer.instancedRenderer': 'Instanced WebGL renderer',
  'notebooks.knowledgeGraph.visualizer.largeGraphHint': 'Large graph: use filters/search for focused exploration',
  'notebooks.knowledgeGraph.visualizer.communityEntities': '{size} entities',
  'notebooks.knowledgeGraph.visualizer.level.sector': 'Sector',
  'notebooks.knowledgeGraph.visualizer.level.system': 'System',
  'notebooks.knowledgeGraph.visualizer.level.subsystem': 'Subsystem',
  'notebooks.knowledgeGraph.visualizer.level.component': 'Component',
  'notebooks.knowledgeGraph.visualizer.level.element': 'Element',

  'notebooks.knowledgeGraph.inspector.noSelection': 'No Selection',
  'notebooks.knowledgeGraph.inspector.clickHint': 'Click on a node in the graph to view details',
  'notebooks.knowledgeGraph.inspector.connections': '{count} connections',
  'notebooks.knowledgeGraph.inspector.frequency': '{count} frequency',
  'notebooks.knowledgeGraph.inspector.levelLabel': 'Level {level}',
  'notebooks.knowledgeGraph.inspector.entitiesBadge': '{count} entities',
  'notebooks.knowledgeGraph.inspector.idPrefix': 'ID: ',
  'notebooks.knowledgeGraph.inspector.confPrefix': 'conf ',
  'notebooks.knowledgeGraph.inspector.description': 'Description',
  'notebooks.knowledgeGraph.inspector.multimodalSource': 'Multimodal Source',
  'notebooks.knowledgeGraph.inspector.modality': 'Modality',
  'notebooks.knowledgeGraph.inspector.asset': 'Asset',
  'notebooks.knowledgeGraph.inspector.chunk': 'Chunk',
  'notebooks.knowledgeGraph.inspector.graphAsset': 'Graph asset',
  'notebooks.knowledgeGraph.inspector.previewImage': 'Preview image',
  'notebooks.knowledgeGraph.inspector.downloadImage': 'Download image',
  'notebooks.knowledgeGraph.inspector.communityHierarchy': 'Community Hierarchy',
  'notebooks.knowledgeGraph.inspector.parentCommunities': '↑ Parent Communities ({count})',
  'notebooks.knowledgeGraph.inspector.currentCommunity': '→ Current Community',
  'notebooks.knowledgeGraph.inspector.childCommunities': '↓ Child Communities ({count})',
  'notebooks.knowledgeGraph.inspector.strongestRelationships': 'Strongest Relationships',
  'notebooks.knowledgeGraph.inspector.connectedEntities': 'Connected Entities ({count})',

  // Entity info field labels
  'notebooks.knowledgeGraph.inspector.entityInfo.caption': 'Caption',
  'notebooks.knowledgeGraph.inspector.entityInfo.semantic_summary': 'Semantic Summary',
  'notebooks.knowledgeGraph.inspector.entityInfo.asset_refs': 'Asset Refs',
  'notebooks.knowledgeGraph.inspector.entityInfo.chunk_metadata': 'Chunk Metadata',
  'notebooks.knowledgeGraph.inspector.entityInfo.metadata': 'Metadata',
  'notebooks.knowledgeGraph.inspector.entityInfo.entities': 'Entities',
  'notebooks.knowledgeGraph.inspector.entityInfo.name': 'Name',
  'notebooks.knowledgeGraph.inspector.entityInfo.type': 'Type',
  'notebooks.knowledgeGraph.inspector.entityInfo.description': 'Description',
  'notebooks.knowledgeGraph.inspector.entityInfo.confidence': 'Confidence',

  'notebooks.knowledgeGraph.chat.title': 'Chat',
  'notebooks.knowledgeGraph.chat.description': 'Query text, entities, and multimodal graph context',
  'notebooks.knowledgeGraph.chat.clear': 'Clear',
  'notebooks.knowledgeGraph.chat.modelLabel': 'Model: {model}',
  'notebooks.knowledgeGraph.chat.estCost': 'Est. cost: ${cost} (in {inTokens} + out {outTokens} tk)',
  'notebooks.knowledgeGraph.chat.mode': 'Mode:',
  'notebooks.knowledgeGraph.chat.assets': 'assets',
  'notebooks.knowledgeGraph.chat.assetsCited': '{count} assets cited',
  'notebooks.knowledgeGraph.chat.getStarted': 'Get started',
  'notebooks.knowledgeGraph.chat.getStartedDesc': 'Ask about entities, relationships, or communities in the knowledge graph.',
  'notebooks.knowledgeGraph.chat.runSteps': 'Run Steps',
  'notebooks.knowledgeGraph.chat.step.search': '{mode} search: collect graph and multimodal context',
  'notebooks.knowledgeGraph.chat.step.extract': 'Extract entity IDs from query output',
  'notebooks.knowledgeGraph.chat.step.build': 'Build compact knowledge graph context',
  'notebooks.knowledgeGraph.chat.step.display': 'Display {mode} response',
  'notebooks.knowledgeGraph.chat.hideLogs': 'Hide terminal output',
  'notebooks.knowledgeGraph.chat.showLogs': 'Show terminal output',
  'notebooks.knowledgeGraph.chat.thinking': 'Thinking…',
  'notebooks.knowledgeGraph.chat.queryAttachment': 'Query attachment',
  'notebooks.knowledgeGraph.chat.placeholder': 'Ask a question about the graph…',
  'notebooks.knowledgeGraph.chat.attachTitle': 'Attach image, table, or text query content',
  'notebooks.knowledgeGraph.chat.addTableTitle': 'Add table query content',
  'notebooks.knowledgeGraph.chat.addEquationTitle': 'Add equation query content',
  'notebooks.knowledgeGraph.chat.addTextTitle': 'Add text query content',
  'notebooks.knowledgeGraph.chat.removeAttachment': 'Remove attachment',
  'notebooks.knowledgeGraph.chat.name': 'Name',
  'notebooks.knowledgeGraph.chat.caption': 'Caption',
  'notebooks.knowledgeGraph.chat.pasteCsv': 'Paste CSV, TSV, or Markdown table',
  'notebooks.knowledgeGraph.chat.pasteEquation': 'Paste LaTeX or equation text',
  'notebooks.knowledgeGraph.chat.pasteText': 'Paste related text',
  'notebooks.knowledgeGraph.chat.role.user': 'user',
  'notebooks.knowledgeGraph.chat.role.assistant': 'assistant',
    'notebooks.knowledgeGraph.chat.vlmTitle': 'Ask backend to use vision-capable answering when available',
  'notebooks.knowledgeGraph.chat.includeAssets': 'Include multimodal assets in context',
  'notebooks.knowledgeGraph.chat.inlineTable': 'inline-table-{n}',
  'notebooks.knowledgeGraph.chat.inlineEquation': 'inline-equation-{n}',
  'notebooks.knowledgeGraph.chat.inlineText': 'inline-text-{n}',
  'notebooks.knowledgeGraph.chat.highlights': 'Highlights: {count} entities',

  // Entity types
  'notebooks.knowledgeGraph.entityType.MultimodalImage': 'Multimodal Image',
  'notebooks.knowledgeGraph.entityType.Concept': 'Concept',
  'notebooks.knowledgeGraph.entityType.Product': 'Product',
  'notebooks.knowledgeGraph.entityType.Person': 'Person',
  'notebooks.knowledgeGraph.entityType.Organization': 'Organization',
  'notebooks.knowledgeGraph.entityType.Event': 'Event',
  'notebooks.knowledgeGraph.entityType.Document': 'Document',
  'notebooks.knowledgeGraph.entityType.Location': 'Location',

  // Modalities
  'notebooks.knowledgeGraph.modality.image': 'Image',
  'notebooks.knowledgeGraph.modality.text': 'Text',

}

const notebooksSources = {
  'notebooks.sources.collapsedLabel': 'Sources',
  'notebooks.sources.title': 'Sources',
  'notebooks.sources.add': 'Add Source',
  'notebooks.sources.addNew': 'Add New Source',
  'notebooks.sources.addExisting': 'Add Existing Source',
  'notebooks.sources.empty.title': 'No sources yet',
  'notebooks.sources.empty.description': 'Add your first source to start building your knowledge base.',
  'notebooks.sources.delete.title': 'Delete Source',
  'notebooks.sources.delete.description': 'Are you sure you want to delete this source? This action cannot be undone.',
  'notebooks.sources.delete.cta': 'Delete',
  'notebooks.sources.remove.title': 'Remove Source from Notebook',
  'notebooks.sources.remove.description': 'Are you sure you want to remove this source from the notebook? The source itself will not be deleted.',
  'notebooks.sources.refresh': 'Refresh',
  'notebooks.sources.remove.cta': 'Remove',
}

const notebooksUpload = {
  'notebooks.upload.zoneTitle': 'Drag and drop files here to upload',
  'notebooks.upload.zoneDescription': 'or click to browse. Supports PDF, Word, Excel, PPT, images, video, audio and more',
  'notebooks.upload.dropHint': 'Drop files to upload',
  'notebooks.upload.status.pending': 'Waiting to upload',
  'notebooks.upload.status.uploading': 'Uploading...',
  'notebooks.upload.status.uploaded': 'Uploaded, creating source...',
  'notebooks.upload.status.creatingSource': 'Creating source...',
  'notebooks.upload.status.done': 'Upload complete',
  'notebooks.upload.status.error': 'Upload failed',
  'notebooks.upload.completedCount': '{count} completed',
  'notebooks.upload.failedCount': '{count} failed',
  'notebooks.upload.clearCompleted': 'Clear completed',
}

const notebooksNotes = {
  'notebooks.notes.collapsedLabel': 'Notes',
  'notebooks.notes.title': 'Notes',
  'notebooks.notes.add': 'Write Note',
  'notebooks.notes.empty.title': 'No notes yet',
  'notebooks.notes.empty.description': 'Create your first note to capture insights and observations.',
  'notebooks.notes.badge.ai': 'AI Generated',
  'notebooks.notes.badge.human': 'Human',
  'notebooks.notes.delete.title': 'Delete Note',
  'notebooks.notes.delete.description': 'Are you sure you want to delete this note? This action cannot be undone.',
  'notebooks.notes.delete.cta': 'Delete',
}

const notebooksChat = {
  'notebooks.chat.title': 'Chat with Notebook',
  'notebooks.chat.title.source': 'Chat with Source',
  'notebooks.chat.error.title': 'Unable to load chat',
  'notebooks.chat.error.hint': 'Please try refreshing the page',
  'notebooks.chat.error.notFound': 'This {type} could not be found',
  'notebooks.chat.empty.start': 'Start a conversation about this {contextType}',
  'notebooks.chat.empty.hint': 'Ask questions to understand the content better',
  'notebooks.chat.input.placeholder': 'Ask a question about this {contextType}...',
  'notebooks.chat.input.send': 'to send',
  'notebooks.chat.sessions': 'Sessions',
  'notebooks.chat.sessions.title': 'Chat Sessions',
  'notebooks.chat.sessions.loading': 'Loading sessions...',
  'notebooks.chat.sessions.empty': 'No chat sessions yet',
  'notebooks.chat.sessions.emptyHint': 'Create a session to start chatting',
  'notebooks.chat.sessions.create': 'Create',
  'notebooks.chat.sessions.cancel': 'Cancel',
  'notebooks.chat.sessions.placeholder': 'Session title...',
  'notebooks.chat.sessions.messages': '{count} messages',
  'notebooks.chat.sessions.delete.title': 'Delete Chat Session?',
  'notebooks.chat.sessions.delete.description': 'This action cannot be undone. All messages in this session will be permanently deleted.',
  'notebooks.chat.sessions.delete.confirm': 'Delete',
  'notebooks.chat.model.label': 'Model',
  'notebooks.chat.context.source': 'source',
  'notebooks.chat.context.sources': 'sources',
  'notebooks.chat.context.insight': 'insight',
  'notebooks.chat.context.insights': 'insights',
  'notebooks.chat.context.note': 'note',
  'notebooks.chat.context.notes': 'notes',
  'notebooks.chat.context.notebook': 'notebook',
  'notebooks.chat.context.notebooks': 'notebooks',
  'notebooks.chat.references': 'References',
  'notebooks.chat.graphReferences': 'Knowledge graph references',
  'notebooks.chat.graphReferences.open': 'View in knowledge graph: {name}',
  'notebooks.chat.analysis.show': 'Show analysis',
  'notebooks.chat.analysis.hide': 'Hide analysis',
  'notebooks.chat.analysis.title': 'Structured Parameters',
  'notebooks.chat.analysis.requestPayload': 'Request Payload',
  'notebooks.chat.analysis.contextSummary': 'Context Summary',
  'notebooks.chat.analysis.contextSelection': 'Context Selection',
  'notebooks.chat.analysis.contextRaw': 'Knowledge Retrieval Content',
  'notebooks.chat.analysis.graphContext': 'Knowledge Graph Context',
  'notebooks.chat.analysis.memorySummary': 'Long-term Memory',
  'notebooks.chat.analysis.memoryPayload': 'Long-term Memory Raw Data',
  'notebooks.chat.analysis.llmRequest': 'LLM Request',
  'notebooks.chat.analysis.responseSummary': 'Response Summary',
  'notebooks.chat.actions.save.tooltip': 'Save to note',
  'notebooks.chat.actions.save.missingNotebook': 'Cannot save note: notebook ID not available',
  'notebooks.chat.actions.copy.tooltip': 'Copy to clipboard',
  'notebooks.chat.actions.copy.success': 'Message copied to clipboard',
  'notebooks.chat.actions.copy.error': 'Failed to copy message',
  'notebooks.chat.vector.label': 'Vector',
  'notebooks.chat.vector.tooltip': 'Enable vector/mixed retrieval to search selected sources and notes for relevant content',
  'notebooks.chat.ocr.label': 'OCR',
  'notebooks.chat.ocr.tooltip': 'Enable Optical Character Recognition for images and text in documents',
  'notebooks.chat.graph.label': 'Graph',
  'notebooks.chat.graph.tooltip': 'Enable knowledge graph retrieval to inject extracted entities and relationships into the chat context',
  'notebooks.chat.memory.userId.label': 'User ID',
  'notebooks.chat.memory.userId.placeholder': 'Leave empty to default to the current customer ID, e.g. customer_1234',
  'notebooks.chat.memory.userId.hint': 'Use the `type_id` format, for example `customer_2232` or `user_1234`; customer is preferred by default.',
  'notebooks.chat.memory.section.title': 'User ID and Memory Settings',
  'notebooks.chat.memory.section.description': 'Expand to control profile, memory, and behavior usage and recording.',
  'notebooks.chat.memory.section.expand': 'Expand',
  'notebooks.chat.memory.section.collapse': 'Collapse',
  'notebooks.chat.memory.use.userProfile': 'Use user profile',
  'notebooks.chat.memory.use.userMemory': 'Use user memory',
  'notebooks.chat.memory.use.userBehavior': 'Use user behavior',
  'notebooks.chat.memory.record.userProfile': 'Record user profile',
  'notebooks.chat.memory.record.userMemory': 'Record user memory',
  'notebooks.chat.memory.record.userBehavior': 'Record user behavior',
}

const notebooksEditor = {
  'notebooks.editor.editTitle': 'Edit note',
  'notebooks.editor.createTitle': 'Create note',
  'notebooks.editor.placeholder.title': 'Add a title...',
  'notebooks.editor.placeholder.untitled': 'Untitled Note',
  'notebooks.editor.placeholder.content': 'Write your note content here...',
  'notebooks.editor.loading': 'Loading note…',
  'notebooks.editor.actions.cancel': 'Cancel',
  'notebooks.editor.actions.saving': 'Saving...',
  'notebooks.editor.actions.creating': 'Creating...',
  'notebooks.editor.actions.save': 'Save Note',
  'notebooks.editor.actions.create': 'Create Note',
  'notebooks.editor.validation.contentRequired': 'Content is required',
}

const notebookAssociations = {
  'notebookAssociations.title': 'Notebooks',
  'notebookAssociations.description': 'Manage which notebooks contain this source',
  'notebookAssociations.noNotebooks': 'No notebooks available',
  'notebookAssociations.save': 'Save Changes',
}

const commonCommandPalette = {
  'commandPalette.title': 'Command Palette',
  'commandPalette.description': 'Navigate, search, or ask your knowledge base',
  'commandPalette.placeholder': 'Type a command or search...',
  'commandPalette.section.searchAsk': 'Search & Ask',
  'commandPalette.section.navigation': 'Navigation',
  'commandPalette.section.notebooks': 'Notebooks',
  'commandPalette.section.create': 'Create',
  'commandPalette.section.theme': 'Theme',
  'commandPalette.section.searchPrompt': 'Or search your knowledge base',
  'commandPalette.search.label': 'Search for “{query}”',
  'commandPalette.ask.label': 'Ask about “{query}”',
  'commandPalette.notebooks.loading': 'Loading notebooks...',
  'commandPalette.create.source': 'Create Source',
  'commandPalette.create.notebook': 'Create Notebook',
  'commandPalette.theme.light': 'Light Theme',
  'commandPalette.theme.dark': 'Dark Theme',
  'commandPalette.theme.system': 'System Theme',
}

const commonAddButton = {
  'addButton.add': 'Add',
  'addButton.source': 'Source',
  'addButton.notebook': 'Notebook',
  'addButton.notebook.soon': 'Coming soon',
}

const commonTheme = {
  'theme.toggle.label': 'Theme',
  'theme.toggle.sr': 'Toggle theme',
  'theme.option.light': 'Light',
  'theme.option.dark': 'Dark',
  'theme.option.system': 'System',
}

const commonActions = {
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.stay_tuned': 'Stay Tuned',
  'common.loading': 'Loading...',
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.auto_refresh_on': 'Auto Refresh On',
  'common.auto_refresh_off': 'Auto Refresh Off',
}

const commonConfirmDialog = {
  'confirmDialog.confirm': 'Confirm',
  'confirmDialog.cancel': 'Cancel',
}

const commonErrorBoundary = {
  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.description': 'An unexpected error occurred. Please try refreshing the page.',
  'errorBoundary.details': 'Error Details',
  'errorBoundary.tryAgain': 'Try Again',
  'errorBoundary.refresh': 'Refresh Page',
}

const commonConnection = {
  'connection.api.unreachable.title': 'Unable to Connect to API Server',
  'connection.api.unreachable.subtitle': 'The FishOwn Agent API server could not be reached',
  'connection.db.offline.title': 'Database Connection Failed',
  'connection.db.offline.subtitle': 'The API server is running, but the database is not accessible',
  'connection.guide.heading': 'This usually means:',
  'connection.guide.api.item1': 'The API server is not running',
  'connection.guide.api.item2': 'The API server is running on a different address',
  'connection.guide.api.item3': 'Network connectivity issues',
  'connection.guide.db.item1': 'PostgreSQL is not running',
  'connection.guide.db.item2': 'Database connection settings are incorrect',
  'connection.guide.db.item3': 'Network issues between API and database',
  'connection.quick.heading': 'Quick fixes:',
  'connection.quick.api.title': 'Set the API_URL environment variable:',
  'connection.quick.db.title': 'Check if PostgreSQL is running:',
  'connection.docs.prefix': 'For detailed setup instructions, see:',
  'connection.docs.link': 'FishOwn Agent Documentation',
  'connection.details.toggle': 'Show Technical Details',
  'connection.details.attemptedUrl': 'Attempted URL:',
  'connection.details.message': 'Message:',
  'connection.details.technical': 'Technical Details:',
  'connection.details.stack': 'Stack Trace:',
  'connection.retry': 'Retry Connection',
  'connection.retry.hint': 'Press R or click the button to retry',
  'connection.error.unknown': 'Unknown error occurred',
}

const commonModelSelector = {
  'modelSelector.placeholder': 'Select a model',
  'modelSelector.empty.language': 'No language models available',
  'modelSelector.empty.embedding': 'No embedding models available',
  'modelSelector.empty.speech_to_text': 'No speech-to-text models available',
  'modelSelector.empty.text_to_speech': 'No text-to-speech models available',
  'modelSelector.empty.generic': 'No models available',
}

const modelSelectorDialog = {
  'modelSelector.dialog.title': 'Model Configuration',
  'modelSelector.dialog.description': 'Override the default model for this chat session. Leave empty to use the system default.',
  'modelSelector.dialog.label': 'Model',
  'modelSelector.dialog.placeholder': 'Select a model (or use default)',
  'modelSelector.dialog.option.default': 'Default',
  'modelSelector.dialog.option.systemModel': 'System Model',
  'modelSelector.dialog.defaultWithModel': 'Default ({model})',
  'modelSelector.dialog.systemDefault': 'System Default',
  'modelSelector.dialog.usingCustom': 'This session will use <strong>{model}</strong> instead of the default model.',
  'modelSelector.dialog.reset': 'Reset to Default',
  'modelSelector.dialog.save': 'Save Changes',
  'modelSelector.dialog.defaultModel': 'Default Model',
}

const commonContextToggle = {
  'contextToggle.off': 'Not included in chat',
  'contextToggle.insights': 'Insights only',
  'contextToggle.full': 'Full content',
  'contextToggle.cycle': 'Click to cycle',
}

const commonContextIndicator = {
  'contextIndicator.empty': 'No sources or notes included in context. Toggle icons on cards to include them.',
  'contextIndicator.label': 'Context:',
  'contextIndicator.tooltip.insights': 'Insights for {count} source(s)',
  'contextIndicator.tooltip.sources': '{count} full source(s)',
  'contextIndicator.tooltip.notes': '{count} full note(s)',
  'contextIndicator.tooltip.graph': '{entities} knowledge graph entities / {relationships} relationships',
  'contextIndicator.vectorDisabled': 'Vector retrieval is disabled',
  'contextIndicator.tokens': '{count} tokens',
  'contextIndicator.chars': '{count} chars',
}

const searchPage = {
  'search.page.title': 'Ask and Search',
  'search.page.description': 'Ask your knowledge base or search across sources and notes.',
  'search.page.mode.label': 'Choose a mode',
  'search.page.mode.ariaLabel': 'Ask or search your knowledge base',
  'search.page.mode.ask': 'Ask (beta)',
  'search.page.mode.search': 'Search',
  'search.ask.title': 'Ask Your Knowledge Base (beta)',
  'search.ask.description': 'The LLM will answer your query based on the documents in your knowledge base.',
  'search.ask.question.label': 'Question',
  'search.ask.question.placeholder': 'Enter your question...',
  'search.ask.question.shortcut': 'Press Cmd/Ctrl+Enter to submit',
  'search.ask.error.noEmbeddingModel': "You can't use this feature because you have no embedding model selected. Please set one up in the Models page.",
  'search.ask.models.custom': 'Using Custom Models',
  'search.ask.models.default': 'Using Default Models',
  'search.ask.models.advanced': 'Advanced',
  'search.ask.models.strategy': 'Strategy: {model}',
  'search.ask.models.answer': 'Answer: {model}',
  'search.ask.models.final': 'Final: {model}',
  'search.ask.models.notSet': 'Not set',
  'search.ask.actions.processing': 'Processing...',
  'search.ask.actions.ask': 'Ask',
  'search.ask.actions.saveToNotebooks': 'Save to Notebooks',
  'search.search.title': 'Search',
  'search.search.description': 'Search your knowledge base for specific keywords or concepts',
  'search.search.query.placeholder': 'Enter search query...',
  'search.search.actions.search': 'Search',
  'search.search.query.shortcut': 'Press Enter to search',
  'search.search.options.type.label': 'Search Type',
  'search.search.options.type.noEmbeddingModel': 'Vector search requires an embedding model. Only text search is available.',
  'search.search.options.type.text': 'Text Search',
  'search.search.options.type.vector': 'Vector Search',
  'search.search.options.type.hybrid': 'Hybrid Search',
  'search.search.options.location.label': 'Search In',
  'search.search.options.location.sources': 'Search Sources',
  'search.search.options.location.notes': 'Search Notes',
  'search.results.count': '{count, plural, =0 {No results} one {# result} other {# results}} found',
  'search.results.type': '{type} search',
  'search.results.empty': 'No results found for "{query}"',
  'search.results.matches': 'Matches ({count})',
}

const sourcesPage = {
  'sources.page.title': 'All Sources',
  'sources.page.description': 'Browse all sources across your notebooks. Use arrow keys to navigate and Enter to open.',
  'sources.page.empty.title': 'No sources yet',
  'sources.page.empty.description': 'Sources from all notebooks will appear here',
  'sources.page.error.load': 'Failed to load sources',
  'sources.page.error.delete': 'Failed to delete source',
  'sources.page.success.delete': 'Source deleted successfully',
  'sources.page.table.type': 'Type',
  'sources.page.table.title': 'Title',
  'sources.page.table.created': 'Created',
  'sources.page.table.insights': 'Insights',
  'sources.page.table.embedded': 'Embedded',
  'sources.page.table.knowledgeGraph': 'Knowledge Graph',
  'sources.page.table.actions': 'Actions',
  'sources.page.type.link': 'Link',
  'sources.page.type.file': 'File',
  'sources.page.type.text': 'Text',
  'sources.page.type.unknown': 'Unknown',
  'sources.page.untitled': 'Untitled Source',
  'sources.page.embedded.yes': 'Yes',
  'sources.page.embedded.no': 'No',
  'sources.page.embedded.readyForGraphRAG': 'Graph-ready',
  'sources.page.knowledgeGraph.built': 'Built',
  'sources.page.knowledgeGraph.ready': 'Ready',
  'sources.page.knowledgeGraph.notAvailable': '—',
  'sources.page.loadingMore': 'Loading more sources...',
  'sources.page.delete.title': 'Delete Source',
  'sources.page.delete.description': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
  'sources.page.delete.cta': 'Delete',
}

const auth = {
  'auth.login.title': 'FishOwn Agent',
  'auth.login.description': 'Sign in through the remote authentication portal.',
  'auth.login.remote.iframeTitle': 'Remote authentication portal',
  'auth.login.remote.waiting': 'Waiting for the remote login portal to finish...',
  'auth.login.remote.missingUrl': 'Remote login URL is not configured.',
  'auth.login.remote.missingUrlDescription':
    'Set NEXT_PUBLIC_REMOTE_LOGIN_URL to the remote login page before starting the dashboard.',
  'auth.login.passwordPlaceholder': 'Password',
  'auth.login.signIn': 'Sign In',
  'auth.login.signingIn': 'Signing in...',
  'auth.login.error.connection.title': 'Connection Error',
  'auth.login.error.connection.description': 'Unable to connect to the API server',
  'auth.login.error.connection.detailed': 'Unable to connect to server. Please check if the API is running.',
  'auth.login.error.diagnostics.title': 'Diagnostic Information:',
  'auth.login.error.diagnostics.version': 'Version: {version}',
  'auth.login.error.diagnostics.built': 'Built: {buildTime}',
  'auth.login.error.diagnostics.apiUrl': 'API URL: {apiUrl}',
  'auth.login.error.diagnostics.frontend': 'Frontend: {url}',
  'auth.login.error.diagnostics.checkConsole': 'Check browser console for detailed logs (look for 🔧 [Config] messages)',
  'auth.login.error.retry': 'Retry Connection',
}

const bananaproPage = {
  'bananapro.title': 'Nano Banana Pro Editor',
  'bananapro.engine_badge': 'Gemini 3 Pro',
  'bananapro.description': 'Edit, enhance, and stylize images with one click. Powered by Nano Banana Pro.',
  'bananapro.parameters.title': 'Parameters',
  'bananapro.parameters.description': 'Adjust model, ratio and resolution to match your target image requirements.',
  'bananapro.model_selection': 'Model Selection',
  'bananapro.model_placeholder': 'Select model',
  'bananapro.aspect_ratio': 'Aspect Ratio',
  'bananapro.resolution': 'Resolution',
  'bananapro.images.title': 'Maximum 10 images',
  'bananapro.images.description': 'Add images to edit (optional)',
  'bananapro.images.secondary': 'Leave empty to generate from prompt',
  'bananapro.images.action': 'Try Image Canvas Mode',
  'bananapro.images.empty': 'No images yet. Drop files above to start.',
  'bananapro.prompt': 'Prompt',
  'bananapro.prompt_placeholder': 'Describe the image you want to edit or generate',
  'bananapro.intensity': 'Processing Intensity',

  'bananapro.generate': 'Generate ({credits} Credits)',
  'bananapro.output.title': 'Output',
  'bananapro.output.description': 'Toggle Before / After to preview edits.',
  'bananapro.output.before': 'Before',
  'bananapro.output.after': 'After',
  'bananapro.output.prompt_label': 'Prompt',
  'bananapro.copy_prompt': 'Copy Prompt',
  'bananapro.download_image': 'Download Image',
  'bananapro.edit_again': 'Edit Again',
  'bananapro.recent.title': 'Recent Creations',
}

const imageGeneratorPage = {
  'image_generator.page.title': 'Image Generator',
  'image_generator.page.description': 'Generate images using various AI models.',
  'image_generator.tab.ecommerce': 'E-Commerce',
  'image_generator.tab.midjourney': 'MidJourney',
  'image_generator.tab.nano_banana_pro': 'Nano Banana Pro',
  'image_generator.tab.midjourney_v7': 'Midjourney V7',
  'image_generator.tab.video_generator': 'Video Generator',
}

const videoGeneratorPage = {
  'video_generator.script_settings': 'Script Settings',
  'video_generator.video_subject': 'Video Subject',
  'video_generator.video_subject_placeholder': 'Enter a topic, AI will generate the script automatically',
  'video_generator.script_language': 'Script Language',
  'video_generator.auto_detect': 'Auto Detect',
  'video_generator.generate_script': 'Generate Script & Keywords',
  'video_generator.video_script': 'Video Script',
  'video_generator.video_script_help': 'AI-generated script, editable before generating video',
  'video_generator.generate_keywords': 'Generate Keywords',
  'video_generator.video_keywords': 'Video Keywords',
  'video_generator.video_keywords_help': 'Keywords for searching video materials, comma separated',
  'video_generator.video_settings': 'Video Settings',
  'video_generator.tab_talk_show': 'Talking Head',
  'video_generator.tab_material_video': 'Stock Footage',
  'video_generator.personal_avatar': 'Personal Avatar',
  'video_generator.personal_avatar_selected': 'Selected',
  'video_generator.personal_avatar_placeholder': 'Select a digital avatar for the talking-head video',
  'video_generator.hd_mode': 'HD Mode',
  'video_generator.hd_mode_help': 'Output video in higher resolution, generation time will increase accordingly',
  'video_generator.video_source': 'Video Source',
  'video_generator.pexels': 'Pexels',
  'video_generator.pixabay': 'Pixabay',
  'video_generator.local_file': 'Resource Library',
  'video_generator.video_concat_mode': 'Concat Mode',
  'video_generator.sequential': 'Sequential',
  'video_generator.random': 'Random',
  'video_generator.video_ratio': 'Video Ratio',
  'video_generator.portrait': 'Portrait 9:16',
  'video_generator.landscape': 'Landscape 16:9',
  'video_generator.clip_duration': 'Clip Duration (s)',
  'video_generator.video_count': 'Generate Count',
  'video_generator.coverr': 'Coverr',
  'video_generator.match_materials_to_script': 'Match Materials to Script Order',
  'video_generator.match_materials_to_script_help': 'When enabled, keywords to final synthesis follow narrative order; concat mode locks to sequential',
  'video_generator.video_transition_mode': 'Transition Mode',
  'video_generator.transition_none': 'None',
  'video_generator.transition_shuffle': 'Shuffle',
  'video_generator.transition_fade_in': 'Fade In',
  'video_generator.transition_fade_out': 'Fade Out',
  'video_generator.transition_slide_in': 'Slide In',
  'video_generator.transition_slide_out': 'Slide Out',
  'video_generator.video_encoder': 'Video Encoder',
  'video_generator.encoder_default': 'Default Encoder',
  'video_generator.encoder_help': 'Select video encoding format, defaults to libx264 (CPU)',
  'video_generator.upload_local_files': 'Select from Resource Library',
  'video_generator.upload_local_files_placeholder': 'Please upload materials (mp4, mov, avi, flv, mkv, jpg, jpeg, png) to the resource library first',
  'video_generator.audio_settings': 'Audio Settings',
  'video_generator.tts': 'AI Voiceover',
  'video_generator.upload_voice': 'Upload Voice',
  'video_generator.no_voice': 'No Voiceover',
  'video_generator.upload_voice_from_library': 'Select Narration Video from Resource Library',
  'video_generator.upload_voice_pick_audio': 'Select Audio from Resource Library',
  'video_generator.asr_model': 'ASR Speech-to-Text Model',
  'video_generator.voiceover_service': 'Voiceover Service',
  'video_generator.voiceover_voice': 'Voice',
  'video_generator.voiceover_voice_placeholder': 'Select a voice',
  'video_generator.voiceover_voice_no_voices': 'No voices available for the selected TTS service. Please choose another.',
  'video_generator.voiceover_volume': 'Volume',
  'video_generator.voiceover_speed': 'Speed',
  'video_generator.bgm_source': 'Background Music',
  'video_generator.no_bgm': 'No BGM',
  'video_generator.library_bgm': 'Music Library',
  'video_generator.custom_bgm': 'Custom BGM',
  'video_generator.bgm_volume': 'BGM Volume',
  'video_generator.bgm_library_type': 'Library Type',
  'video_generator.bgm_library_song': 'Select Track',
  'video_generator.bgm_preview': 'Preview',
  'video_generator.bgm_stop': 'Stop',
  'video_generator.bgm_library_total': '{total} tracks available',
  'video_generator.custom_bgm_file': 'Custom BGM File Name',
  'video_generator.custom_bgm_file_placeholder': 'Enter mp3 filename under resource/songs, e.g. bgm01.mp3',
  'video_generator.play_voice': 'Play Voice Preview',
  'video_generator.play_voice_empty': 'Enter a video subject or script first to generate preview content',
  'video_generator.clone_my_voice': 'Clone My Voice',
  'video_generator.clone_my_voice_desc': 'Upload voice samples to generate your custom cloned voice',
  'video_generator.select_voice_with_clone': 'Select Voice (incl. Clone)',
  'video_generator.select_voice_with_clone_placeholder': 'Select a voice',
  'video_generator.voice_emotion': 'Emotion',
  'video_generator.emotion_none': 'None',
  'video_generator.emotion_happy': 'Happy',
  'video_generator.emotion_sad': 'Sad',
  'video_generator.emotion_angry': 'Angry',
  'video_generator.emotion_fearful': 'Fearful',
  'video_generator.emotion_disgusted': 'Disgusted',
  'video_generator.emotion_surprised': 'Surprised',
  'video_generator.emotion_calm': 'Calm',
  'video_generator.upload_voice_file': 'Upload Voice File',
  'video_generator.upload_voice_file_help': 'Supports mp3, wav, m4a, aac, flac, ogg formats',
  'video_generator.upload_voice_file_info': 'Uploaded audio will be used directly, TTS synthesis will be skipped.',
  'video_generator.azure_speech_region': 'Azure Speech Region',
  'video_generator.azure_speech_key': 'Azure Speech Key',
  'video_generator.siliconflow_api_key': 'SiliconFlow API Key',
  'video_generator.gemini_tts_api_key': 'Google Gemini API Key',
  'video_generator.mimo_api_key': 'MiMo API Key',
  'video_generator.elevenlabs_api_key': 'ElevenLabs API Key',
  'video_generator.elevenlabs_model': 'ElevenLabs Model',
  'video_generator.chatterbox_base_url': 'Chatterbox Base URL',
  'video_generator.chatterbox_base_url_placeholder': 'http://127.0.0.1:4123/v1',
  'video_generator.chatterbox_api_key': 'Chatterbox API Key',
  'video_generator.chatterbox_model': 'Chatterbox Model',
  'video_generator.chatterbox_voices': 'Chatterbox Voices',
  'video_generator.chatterbox_voices_placeholder': 'Comma-separated, e.g. default-Female, default-Male',
  'video_generator.subtitle_settings': 'Video Editing',
  'video_generator.enable_subtitles': 'Enable Subtitles',
  'video_generator.subtitle_font': 'Font',
  'video_generator.subtitle_position': 'Position',
  'video_generator.subtitle_top': 'Top',
  'video_generator.subtitle_bottom': 'Bottom',
  'video_generator.subtitle_color': 'Font Color',
  'video_generator.subtitle_font_size': 'Font Size',
  'video_generator.subtitle_stroke_color': 'Stroke Color',
  'video_generator.subtitle_stroke_width': 'Stroke Width',
  'video_generator.subtitle_center': 'Center',
  'video_generator.subtitle_custom': 'Custom',
  'video_generator.custom_position': 'Custom Position (% from top)',
  'video_generator.custom_position_invalid': 'Please enter a valid number between 0 and 100',
  'video_generator.subtitle_background_enabled': 'Enable Subtitle Background',
  'video_generator.subtitle_background_color': 'Background Color',
  'video_generator.rounded_subtitle_background': 'Rounded Background',
  'video_generator.rounded_subtitle_background_help': 'Add rounded corners to the subtitle background',
  'video_generator.restore_default_subtitle': 'Restore Default Subtitle Settings',
  'video_generator.default_subtitle_restored': 'Default subtitle settings restored',
  'video_generator.generate_video': 'Generate Video',
  'video_generator.please_enter_subject': 'Please enter a video subject first',
  'video_generator.please_enter_script': 'Please enter the video script first',
  'video_generator.advanced_script_settings': 'Advanced Script Settings',
  'video_generator.paragraph_number': 'Paragraph Number',
  'video_generator.custom_script_requirements': 'Custom Script Requirements',
  'video_generator.custom_script_requirements_placeholder': 'Enter additional requirements, e.g. "no more than 50 words per paragraph", "use a lighthearted tone"',
  'video_generator.custom_system_prompt': 'Custom System Prompt',
  'video_generator.restore_default_prompt': 'Restore Default Prompt',
  'video_generator.default_prompt_restored': 'Default system prompt restored',
  'video_generator.preview_final_prompt': 'Preview Final Prompt',
  'video_generator.final_prompt_preview': 'Final Prompt Preview',
  'video_generator.close': 'Close',
  'video_generator.task_manager': 'Task Manager',
  'video_generator.task_manager_no_tasks': 'No tasks yet',
  'video_generator.task_status_all': 'All',
  'video_generator.task_status_processing': 'Processing',
  'video_generator.task_status_complete': 'Complete',
  'video_generator.task_status_failed': 'Failed',
  'video_generator.task_subject': 'Subject',
  'video_generator.task_updated_at': 'Updated',
  'video_generator.task_progress': 'Progress',
  'video_generator.task_actions': 'Actions',
  'video_generator.settings': 'Settings',
  'video_generator.settings_material_api': 'Material API',
  'video_generator.settings_cache_management': 'Cache Management',
  'video_generator.pexels_api_key': 'Pexels API Key',
  'video_generator.pixabay_api_key': 'Pixabay API Key',
  'video_generator.coverr_api_key': 'Coverr API Key',
  'video_generator.coverr_api_key_help': 'Coverr footage is mostly 16:9 landscape; set aspect ratio to landscape when using Coverr.',
  'video_generator.get_api_key': 'Get API Key',
  'video_generator.credential_mode': 'Configuration',
  'video_generator.credential_mode_system': 'System Config',
  'video_generator.credential_mode_custom': 'Custom Config',
  'video_generator.api_key_status_system': 'Using system-configured API Key',
  'video_generator.api_key_status_tenant': 'Tenant Key configured',
  'video_generator.api_key_placeholder': 'Enter API Key',
  'video_generator.auto_saved': 'Auto-saved',
  'video_generator.saving': 'Saving...',
  'video_generator.cache_directory': 'Cache Directory',
  'video_generator.cache_file_count': 'File Count',
  'video_generator.cache_total_size': 'Total Size',
  'video_generator.cache_oldest_date': 'Oldest Date',
  'video_generator.cache_cleanup_range': 'Cleanup Range',
  'video_generator.cache_older_than_30_days': 'Older than 30 days',
  'video_generator.cache_older_than_7_days': 'Older than 7 days',
  'video_generator.cache_older_than_90_days': 'Older than 90 days',
  'video_generator.cache_all': 'All Cache',
  'video_generator.cache_cleanup_preview': '{count} files, {size} to be cleaned',
  'video_generator.cache_cleanup_confirm': 'Confirm cache cleanup',
  'video_generator.refresh_cache': 'Refresh Stats',
  'video_generator.clean_cache_now': 'Clean Now',
  'video_generator.cache_cleanup_completed': 'Cleaned {count} files, freed {size}',
  'video_generator.cache_cleanup_failed': 'Cleanup done: {count} deleted, {failed} failed',
  'video_generator.api_key_saved': 'API Key saved',
  'video_generator.task_delete': 'Delete',
  'video_generator.task_delete_confirm_title': 'Confirm Delete Task',
  'video_generator.task_delete_confirm_description': 'Deleting task "{subject}" will remove it from the list; related files remain on the server.',
  'video_generator.task_delete_confirm_running': 'The running job will be stopped first. Task "{subject}" will be marked as failed; related files remain on the server.',
  'video_generator.task_delete_success': 'Task deleted',
  'video_generator.task_delete_failed': 'Failed to delete task',
  'video_generator.task_delete_running_warning': 'This task is currently running. It will be stopped and marked as failed before deletion.',
  'video_generator.tab_original_copy': 'Original Copy',
  'video_generator.tab_borrow_wind': 'Rewrite',
  'video_generator.douyin_link_placeholder': 'Paste Douyin share content or video link...',
  'video_generator.extract_script': 'Extract Script',
  'video_generator.target_video_script': 'Target Video Script',
  'video_generator.rewrite_script_and_keywords': 'Rewrite Script & Keywords',
  'video_generator.borrow_wind_video_script': 'Video Script',
  'video_generator.borrow_wind_video_keywords': 'Video Keywords',
  'video_generator.upload_reference_video': 'Upload Reference Video',
  'video_generator.upload_reference_video_help': 'Upload video files for script extraction and rewriting',
  'video_generator.extracting_script': 'Extracting script...',
  'video_generator.extract_script_success': 'Script extracted successfully',
  'video_generator.extract_script_failed': 'Script extraction failed',
  'video_generator.extract_script_no_source': 'Please select a reference video first',
  'video_generator.extract_script_cache_hint': 'Using cached script from the material library',
}


const addSourceDialog = {
  'addSourceDialog.title': 'Add New Source',
  'addSourceDialog.description': 'Add content from links, uploads, or text to your notebooks.',
  'addSourceDialog.step1.title': 'Source & Content',
  'addSourceDialog.step1.description': 'Choose type and add content',
  'addSourceDialog.step2.title': 'Organization',
  'addSourceDialog.step2.description': 'Select notebooks',
  'addSourceDialog.step3.title': 'Processing',
  'addSourceDialog.validation.required': 'Please provide the required content for the selected source type',
  'addSourceDialog.validation.titleRequired': 'Title is required for text sources',
  'addSourceDialog.processing.batchMessage': 'Processing {itemCount} sources...',
  'addSourceDialog.processing.batchSuccess': '{successCount} source(s) created successfully',
  'addSourceDialog.processing.batchFailed': 'Failed to create all {failedCount} sources',
  'addSourceDialog.processing.batchPartial': '{successCount} succeeded, {failedCount} failed',
  'addSourceDialog.processing.singleMessage': 'Submitting source for processing...',
  'addSourceDialog.processing.errorMessage': 'Error creating source. Please try again.',
  'addSourceDialog.processing.batchTitle': 'Processing Batch',
  'addSourceDialog.processing.singleTitle': 'Processing Source',
  'addSourceDialog.processing.batchDescription': 'Processing {total} sources. This may take a few moments.',
  'addSourceDialog.processing.singleDescription': 'Your source is being processed. This may take a few moments.',
  'addSourceDialog.processing.label': 'Processing...',
  'addSourceDialog.processing.completed': '{completed} completed',
  'addSourceDialog.processing.failed': '{failed} failed',
  'addSourceDialog.processing.currentItem': 'Current: {currentItem}',
  'addSourceDialog.actions.cancel': 'Cancel',
  'addSourceDialog.actions.back': 'Back',
  'addSourceDialog.actions.next': 'Next',
  'addSourceDialog.actions.creating': 'Creating...',
  'addSourceDialog.actions.done': 'Done',
  'addSourceDialog.type.link.label': 'Link',
  'addSourceDialog.type.link.description': 'Add a web page or URL',
  'addSourceDialog.type.upload.label': 'Upload',
  'addSourceDialog.type.upload.description': 'Upload a document or file',
  'addSourceDialog.type.text.label': 'Text',
  'addSourceDialog.type.text.description': 'Add text content directly',
  'addSourceDialog.type.title': 'Source Type',
  'addSourceDialog.type.description': 'Choose how you want to add your content',
  'addSourceDialog.type.link.labelUrl': 'URL(s) *',
  'addSourceDialog.type.link.urlCount': '{count} URL',
  'addSourceDialog.type.link.urlCount_plural': '{count} URLs',
  'addSourceDialog.type.maxSize': 'max {size}',
  'addSourceDialog.type.link.placeholder': 'Enter URLs, one per line\nhttps://example.com/article1\nhttps://example.com/article2',
  'addSourceDialog.type.link.batchHint': 'Paste multiple URLs (one per line) to batch import',
  'addSourceDialog.type.link.invalidUrlError': 'Invalid URLs detected:',
  'addSourceDialog.type.link.line': 'Line {line}',
  'addSourceDialog.type.link.fixInvalidUrlHint': 'Please fix or remove invalid URLs to continue',
  'addSourceDialog.type.upload.labelFile': 'File(s) *',
  'addSourceDialog.type.upload.fileCount': '{count} file',
  'addSourceDialog.type.upload.fileCount_plural': '{count} files',
  'addSourceDialog.type.upload.batchHint': 'Select multiple files to batch import. Supported: Documents (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), Media (MP4, MP3, WAV, M4A), Images (JPG, PNG), Archives (ZIP)',
  'addSourceDialog.type.upload.selectedFiles': 'Selected files:',
  'addSourceDialog.type.upload.fileSize': '{size} KB',
  'addSourceDialog.type.upload.maxSizeError': 'Maximum {size} files allowed per batch',
  'addSourceDialog.type.text.labelContent': 'Text Content *',
  'addSourceDialog.type.text.placeholder': 'Paste or type your content here...',
  'addSourceDialog.title.required': 'Title *',
  'addSourceDialog.title.optional': 'Title (optional)',
  'addSourceDialog.title.textHint': 'A title is required for text content',
  'addSourceDialog.title.genericHint': 'If left empty, a title will be generated from the content',
  'addSourceDialog.title.placeholder': 'Give your source a descriptive title',
  'addSourceDialog.batchMode.title': 'Batch Mode',
  'addSourceDialog.batchMode.description': '{count} {type} will be processed',
  'addSourceDialog.step2.notebooks.title': 'Select Notebooks (optional)',
  'addSourceDialog.step2.notebooks.description': 'Choose which notebooks should contain this source. You can select multiple notebooks or leave this empty.',
  'addSourceDialog.step2.notebooks.empty': 'No notebooks found.',
  'addSourceDialog.step3.processing.title': 'Processing Settings',
  'addSourceDialog.step3.processing.description': 'Configure how your source will be processed and stored.',
  'addSourceDialog.step3.processing.embed.label': 'Enable embedding for search',
  'addSourceDialog.step3.processing.embed.description': 'Allows this source to be found in vector searches and AI queries',
  'addSourceDialog.step3.processing.embed.auto.label': 'Embedding enabled automatically',
  'addSourceDialog.step3.processing.embed.auto.description': 'Your settings are configured to always embed content for vector search. You can change this in {settingsLink}.',
  'addSourceDialog.step3.processing.embed.disabled.label': 'Embedding disabled',
  'addSourceDialog.step3.processing.embed.disabled.description': "Your settings are configured to skip embedding. Vector search won't be available for this source. You can change this in {settingsLink}.",
  'addSourceDialog.error.noOcrModel': 'Unable to enable OCR as no OCR model is selected. Please configure one in the Models page.',
  'addSourceDialog.step3.processing.graphrag.label': 'Enable knowledge graph indexing (GraphRAG)',
  'addSourceDialog.step3.processing.graphrag.description': 'Build entity and relationship graphs for complex Q&A and knowledge discovery',
}

const addExistingSourceDialog = {
  'addExistingSourceDialog.title': 'Add Existing Sources',
  'addExistingSourceDialog.description': 'Search and select existing sources to add to this notebook',
  'addExistingSourceDialog.searchPlaceholder': 'Search sources...',
  'addExistingSourceDialog.loading': 'Loading sources...',
  'addExistingSourceDialog.noResults': 'No sources found',
  'addExistingSourceDialog.untitled': 'Untitled',
  'addExistingSourceDialog.linked': 'Linked',
  'addExistingSourceDialog.addedOn': 'Added {date}',
  'addExistingSourceDialog.truncationWarning': 'Showing first 100 sources. Use the Search feature to find specific sources.',
  'addExistingSourceDialog.selectionCount': 'Selected {count} sources',
  'addExistingSourceDialog.selectionCount_plural': 'Selected {count} sources',
  'addExistingSourceDialog.actions.cancel': 'Cancel',
  'addExistingSourceDialog.actions.adding': 'Adding...',
  'addExistingSourceDialog.actions.addSelected': 'Add Selected',
}

const createNotebookDialog = {
  'createNotebookDialog.title': 'Create New Notebook',
  'createNotebookDialog.description': 'Create a dedicated space for related sources and notes to start organizing your research.',
  'createNotebookDialog.name.label': 'Name *',
  'createNotebookDialog.name.placeholder': 'Enter notebook name',
  'createNotebookDialog.name.required': 'Name is required',
  'createNotebookDialog.description.label': 'Description',
  'createNotebookDialog.description.placeholder': 'Describe the purpose and scope of this notebook...',
  'createNotebookDialog.actions.cancel': 'Cancel',
  'createNotebookDialog.actions.creating': 'Creating…',
  'createNotebookDialog.actions.create': 'Create Notebook',
}

const collapsibleColumn = {
  'collapsibleColumn.expand': 'Expand {label}',
  'collapsibleColumn.collapse': 'Collapse {label}',
}

const modelsPage = {
  'models.page.loadError': 'Failed to load model data',
  'models.page.title': 'Model Management',
  'models.page.description': 'Configure AI models for different purposes across FishOwn Agent',
}

const providerStatus = {
  'providerStatus.title': 'AI Providers',
  'providerStatus.description': 'Configure providers through environment variables to enable their models.',
  'providerStatus.configured': '{count} of {total} configured',
  'providerStatus.noModels': 'No models',
  'providerStatus.notConfigured': 'Not configured',
  'providerStatus.seeLess': 'See less',
  'providerStatus.seeAll': 'See all {count} providers',
  'providerStatus.learnMore': 'Learn how to configure providers →',
  'providerStatus.type.language': 'Language',
  'providerStatus.type.embedding': 'Embedding',
  'providerStatus.type.text_to_speech': 'Text to Speech',
  'providerStatus.type.speech_to_text': 'Speech to Text',
  'providerStatus.type.ocr': 'OCR',
  'providerStatus.type.image': 'Image',
  'providerStatus.type.video': 'Video',
  'providerStatus.type.music': 'Music',
  'providerStatus.type.3d': '3D Model',
  'providerStatus.displayName.fishownapi': 'Fishown API (Platform Proxy)',
  'providerStatus.displayName.ollama': 'Ollama',
  'providerStatus.displayName.openai': 'OpenAI',
  'providerStatus.displayName.google': 'Google Gemini',
  'providerStatus.displayName.anthropic': 'Anthropic Claude',
  'providerStatus.displayName.deepseek': 'DeepSeek',
  'providerStatus.displayName.minimax': 'MiniMax',
  'providerStatus.displayName.moonshot': 'Moonshot AI',
  'providerStatus.displayName.alibaba': 'Alibaba Bailian',
  'providerStatus.displayName.volcengine': 'VolcEngine',
  'providerStatus.displayName.glm': 'Zhipu GLM',
  'providerStatus.displayName.groq': 'Groq',
  'providerStatus.displayName.xai': 'xAI',
  'providerStatus.displayName.vertex': 'Vertex AI',
  'providerStatus.displayName.openrouter': 'OpenRouter',
  'providerStatus.displayName.elevenlabs': 'ElevenLabs',
  'providerStatus.displayName.voyage': 'Voyage',
  'providerStatus.displayName.azure': 'Azure OpenAI',
  'providerStatus.displayName.mistral': 'Mistral',
  'providerStatus.displayName.midjourney': 'Midjourney',
  'providerStatus.displayName.comfyui': 'ComfyUI',
  'providerStatus.displayName.openai-compatible': 'OpenAI Compatible',
  'providerStatus.displayName.openai_compatible': 'OpenAI Compatible',
}

const providerSettings = {
  'providerSettings.title': 'Configure {provider}',
  'providerSettings.description': 'Enter your API keys and other configuration details.',
  'providerSettings.placeholder': 'Enter {key}',
  'providerSettings.noSettings': 'No configuration needed for this provider.',
  'providerSettings.validation.required': 'This field is required.',
  'providerSettings.field.api_key': 'API Key',
  'providerSettings.field.base_url': 'Base URL',
  'providerSettings.field.timeout': 'Timeout (s)',
  'providerSettings.field.max_tokens': 'Max Tokens',
  'providerSettings.field.temperature': 'Temperature',
  'providerSettings.field.gemini_api_key': 'Gemini API Key',
  'providerSettings.field.project': 'Project',
  'providerSettings.field.location': 'Location',
  'providerSettings.field.credentials': 'Credentials JSON Path',
  'providerSettings.field.endpoint': 'Endpoint',
  'providerSettings.field.api_version': 'API Version',
}

const modelTypeSection = {
  'modelTypeSection.languageModels.title': 'Language Models',
  'modelTypeSection.languageModels.description': 'Chat, reasoning, and text generation',
  'modelTypeSection.embeddingModels.title': 'Embedding Models',
  'modelTypeSection.embeddingModels.description': 'Semantic search and vector embeddings',
  'modelTypeSection.textToSpeech.title': 'Text-to-Speech',
  'modelTypeSection.textToSpeech.description': 'Generate audio from text',
  'modelTypeSection.speechToText.title': 'Speech-to-Text',
  'modelTypeSection.speechToText.description': 'Transcribe audio to text',
  'modelTypeSection.ocrModels.title': 'OCR Models',
  'modelTypeSection.ocrModels.description': 'Optical Character Recognition',
  'modelTypeSection.imageModels.title': 'Image Models',
  'modelTypeSection.imageModels.description': 'Image generation and processing',
  'modelTypeSection.videoModels.title': 'Video Models',
  'modelTypeSection.videoModels.description': 'Video generation and processing',
  'modelTypeSection.musicModels.title': 'Music Models',
  'modelTypeSection.musicModels.description': 'Music generation and processing',
  'modelTypeSection.3dModels.title': '3D Models',
  'modelTypeSection.3dModels.description': '3D model generation and processing',
  'modelTypeSection.filter.all': 'All',
  'modelTypeSection.noModels.configured': 'No models configured',
  'modelTypeSection.noModels.providerConfigured': 'No {provider} models configured',
  'modelTypeSection.noModels.badge': 'No models',
  'modelTypeSection.notConfigured.badge': 'Not configured',
  'modelTypeSection.showLess': 'Show less',
  'modelTypeSection.showMore': 'Show {count} more',
  'modelTypeSection.deleteModel.title': 'Delete Model',
  'modelTypeSection.deleteModel.description': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
  'modelTypeSection.deleteModel.confirm': 'Delete',
  'modelTypeSection.dimension': 'Dim: {dim}',
  'modelTypeSection.badge.systemModel': 'System Model',
  'modelTypeSection.badge.systemBilling': 'Platform Billed',
  'modelTypeSection.tag.img_in': 'Image input supported',
  'modelTypeSection.tag.video_in': 'Video input supported',
  'modelTypeSection.capability.text_in': 'Text input',
  'modelTypeSection.capability.img_in': 'Image input',
  'modelTypeSection.capability.video_in': 'Video input',
  'modelTypeSection.capability.audio_in': 'Audio input',
  'modelTypeSection.capability.function_calling': 'Function Call',
  'modelTypeSection.capability.deep_thinking': 'Deep thinking',
  'modelTypeSection.capability.web_search': 'Web search',
  'modelTypeSection.capability.structured_output': 'Structured output',
  'modelTypeSection.capability.text_out': 'Text output',
  'modelTypeSection.capability.img_out': 'Image output',
  'modelTypeSection.capability.video_out': 'Video output',
  'modelTypeSection.capability.audio_out': 'Audio output',
  'modelTypeSection.capability.cache': 'Cache',
  'modelTypeSection.capability.fine_tuning': 'Fine-tuning',
  'modelTypeSection.capability.batch_inference': 'Batch inference',
  'modelTypeSection.popover.modelId': 'Model ID',
  'modelTypeSection.popover.introduction': 'Introduction',
  'modelTypeSection.popover.ioModality': 'Input / Output Modalities',
  'modelTypeSection.popover.capabilities': 'Capabilities',
  'modelTypeSection.popover.limits': 'Limits',
  'modelTypeSection.popover.contextWindow': '{val} context window',
  'modelTypeSection.popover.maxInputTokens': 'Max input {val}',
  'modelTypeSection.popover.maxOutputTokens': 'Max output {val}',
  'modelTypeSection.popover.maxThinkingTokens': 'Max thinking {val}',
  'modelTypeSection.popover.tpm': 'TPM {val}',
  'modelTypeSection.popover.rpm': 'RPM {val}',
  'modelTypeSection.popover.videoResolution': 'Resolution: {val}',
  'modelTypeSection.popover.videoDuration': 'Duration: {val}-{val2}s',
  'modelTypeSection.popover.videoFps': 'FPS: {val}',
  'modelTypeSection.popover.watermark': 'Watermarked',
  'modelTypeSection.popover.concurrency': 'Concurrency: {val}',
}

const modelPricing = {
  'modelPricing.buttonText': 'Model Pricing',
  'modelPricing.title': 'Model Pricing',
  'modelPricing.description': 'Pricing details for platform system models',
  'modelPricing.empty': 'No system model pricing information available',
  'modelPricing.modelCount': 'models',
  'modelPricing.input': 'Input',
  'modelPricing.output': 'Output',
  'modelPricing.perUse': 'Per use',
  'modelPricing.noDetail': 'No detailed pricing information',
  'modelPricing.noPricing': 'No pricing',
  'modelPricing.billingMode': 'Billing mode',
  'modelPricing.table.type': 'Type',
  'modelPricing.table.price': 'Price',
  'modelPricing.table.discountPrice': 'Discount',
}

const defaultModelsSection = {
  'defaultModelsSection.title': 'Default Model Assignments',
  'defaultModelsSection.description': 'Configure which models to use for different purposes across FishOwn Agent',
  'defaultModelsSection.chatModel.label': 'Chat Model',
  'defaultModelsSection.chatModel.description': 'Used for chat conversations',
  'defaultModelsSection.transformationModel.label': 'Transformation Model',
  'defaultModelsSection.transformationModel.description': 'Used for summaries, insights, and transformations',
  'defaultModelsSection.toolsModel.label': 'Multimodal Tools Model',
  'defaultModelsSection.toolsModel.description': 'Used for function calling and structured extraction — needs vision + function calling support',
  'defaultModelsSection.toolsModel.multimodalHint': '💡 Creation prompt generation requires both image understanding (vision) and function calling. Click 「推荐模型参考」 below for details.',
  'defaultModelsSection.largeContextModel.label': 'Large Context Model',
  'defaultModelsSection.largeContextModel.description': 'Used for processing large documents - Gemini recommended',
  'defaultModelsSection.ocrModel.label': 'OCR Model',
  'defaultModelsSection.ocrModel.description': 'Used for extracting text from images and documents',
  'defaultModelsSection.embeddingModel.label': 'Embedding Model',
  'defaultModelsSection.embeddingModel.description': 'Used for semantic search and vector embeddings',
  'defaultModelsSection.textToSpeechModel.label': 'Text-to-Speech Model',
  'defaultModelsSection.textToSpeechModel.description': 'Used for speech synthesis',
  'defaultModelsSection.speechToTextModel.label': 'Speech-to-Text Model',
  'defaultModelsSection.speechToTextModel.description': 'Used for audio transcription',
  'defaultModelsSection.imageModel.label': 'Image Model',
  'defaultModelsSection.imageModel.description': 'Used for image generation and processing',
  'defaultModelsSection.3dModel.label': '3D Model',
  'defaultModelsSection.3dModel.description': 'Used for 3D model generation and processing',
  'defaultModelsSection.missingRequired': 'Missing required models: {models}. FishOwn Agent may not function properly without these.',
  'defaultModelsSection.selectModel.required': '⚠️ Required - Select a model',
  'defaultModelsSection.selectModel.placeholder': 'Select a model',
  'defaultModelsSection.option.systemModel': 'System Model',
  'defaultModelsSection.learnMore': 'Which model should I choose? →',
}

const addModelForm = {
  'addModelForm.button': 'Add Model',
  'addModelForm.dialog.title': 'Add {type} Model',
  'addModelForm.dialog.description': 'Configure a new {type} model from available providers.',
  'addModelForm.noProviders': 'No providers available for {type} models',
  'addModelForm.embeddingDisabled': 'Embedding models are system-preset and cannot be added manually',
  'addModelForm.provider.label': 'Provider',
  'addModelForm.provider.placeholder': 'Select a provider',
  'addModelForm.provider.required': 'Provider is required',
  'addModelForm.name.label': 'Model Name',
  'addModelForm.name.required': 'Model name is required',
  'addModelForm.name.placeholder.language': 'e.g., gpt-5-mini, claude, gemini',
  'addModelForm.name.placeholder.embedding': 'e.g., text-embedding-3-small',
  'addModelForm.name.placeholder.textToSpeech': 'e.g., tts-gpt-4o-mini-tts, tts-1-hd',
  'addModelForm.name.placeholder.speechToText': 'e.g., whisper-1',
  'addModelForm.name.placeholder.ocr': 'e.g., gpt-4-o, gemma2-9b-it',
  'addModelForm.name.placeholder.image': 'e.g., dall-e-3, stable-diffusion-xl',
  'addModelForm.name.placeholder.video': 'e.g., sora, runway-gen3',
  'addModelForm.name.placeholder.music': 'e.g., suno-v4, musicgen',
  'addModelForm.name.placeholder.3d': 'e.g., meshy-4, tripo3d',
  'addModelForm.name.placeholder.default': 'Enter model name',
  'addModelForm.name.azureHint': 'For Azure, use the deployment name as the model name',
  'addModelForm.actions.cancel': 'Cancel',
  'addModelForm.actions.adding': 'Adding...',
  'addModelForm.actions.addModel': 'Add Model',
  'addModelForm.tags.label': 'Tags',
  'addModelForm.tags.placeholder': 'Enter tags, separated by commas',
  'addModelForm.tags.img_in': 'Image Input',
  'addModelForm.tags.video_in': 'Video Input',
  'addModelForm.tags.helpText': 'Label model characteristics (e.g., multimodal, deep thinking, vision)',
  'addModelForm.tags.inputPlaceholder': 'Type a tag and press Enter',
  'addModelForm.tags.presets': 'Quick add:',
  'addModelForm.capabilities.label': 'Capabilities',
  'addModelForm.capabilities.modality.label': 'Input / Output Modalities',
  'addModelForm.capabilities.modality.inputLabel': 'Input modalities',
  'addModelForm.capabilities.modality.outputLabel': 'Output modalities',
  'addModelForm.capabilities.modality.text_in': 'Text input',
  'addModelForm.capabilities.modality.img_in': 'Image input',
  'addModelForm.capabilities.modality.video_in': 'Video input',
  'addModelForm.capabilities.modality.audio_in': 'Audio input',
  'addModelForm.capabilities.modality.text_out': 'Text output',
  'addModelForm.capabilities.modality.img_out': 'Image output',
  'addModelForm.capabilities.modality.video_out': 'Video output',
  'addModelForm.capabilities.modality.audio_out': 'Audio output',
  'addModelForm.capabilities.features.label': 'Features',
  'addModelForm.capabilities.features.function_calling': 'Function Call',
  'addModelForm.capabilities.features.structured_output': 'Structured output',
  'addModelForm.capabilities.features.deep_thinking': 'Deep thinking',
  'addModelForm.capabilities.features.web_search': 'Web search',
  'addModelForm.capabilities.features.cache': 'Cache',
  'addModelForm.capabilities.features.fine_tuning': 'Fine-tuning',
  'addModelForm.capabilities.features.batch_inference': 'Batch inference',
}

const embeddingModelChangeDialog = {
  'embeddingModelChangeDialog.title': 'Embedding Model Change',
  'embeddingModelChangeDialog.description.intro': 'You are about to change your embedding model',
  'embeddingModelChangeDialog.description.fromTo': 'from **{oldModelName}** to **{newModelName}**',
  'embeddingModelChangeDialog.description.important': 'Important: Rebuild Required',
  'embeddingModelChangeDialog.description.rebuildWarning': 'Changing your embedding model requires rebuilding all existing embeddings to maintain consistency. Without rebuilding, your searches may return incorrect or incomplete results.',
  'embeddingModelChangeDialog.description.whatHappensNext': 'What happens next:',
  'embeddingModelChangeDialog.description.updated': 'Your default embedding model will be updated',
  'embeddingModelChangeDialog.description.unchanged': 'Existing embeddings will remain unchanged until rebuild',
  'embeddingModelChangeDialog.description.newContent': 'New content will use the new embedding model',
  'embeddingModelChangeDialog.description.rebuildSoon': 'You should rebuild embeddings as soon as possible',
  'embeddingModelChangeDialog.description.proceedQuestion': 'Would you like to proceed to the Advanced page to start the rebuild now?',
  'embeddingModelChangeDialog.actions.cancel': 'Cancel',
  'embeddingModelChangeDialog.actions.changeModelOnly': 'Change Model Only',
  'embeddingModelChangeDialog.actions.changeAndRebuild': 'Change & Go to Rebuild',
}



const digitalEmployeesPage = {
  'digital_employees.title': 'Mobile Employees',
  'digital_employees.description': 'Manage your digital employees.',
  'digital_employees.view.table': 'Table',
  'digital_employees.view.cards': 'Cards',

  'digital_employees.table.empty': 'No digital employees',
  'digital_employees.table.select_all': 'Select all',
  'digital_employees.table.select_row': 'Select row',
  'digital_employees.table.serial': 'ID',
  'digital_employees.table.name': 'Name',
  'digital_employees.table.login': 'Login',
  'digital_employees.table.type': 'Type',
  'digital_employees.table.mode': 'Mode',
  'digital_employees.table.available': 'Available',
  'digital_employees.table.status': 'Status',
  'digital_employees.table.expired_at': 'Expires',
  'digital_employees.table.control': 'Controls',

  'digital_employees.type.1': 'RedBook KOL',
  'digital_employees.type.2': 'Video Account KOL',
  'digital_employees.type.3': 'TikTok KOL',
  'digital_employees.type.4': 'WeChat Add Friend',
  'digital_employees.type.5': 'Douyin KOL',
  'digital_employees.type.12': 'Mail Broadcast',
  'digital_employees.type.14': 'Boss Zhipin',
  'digital_employees.type.16': 'Qiwei Private',
  'digital_employees.type.17': 'Qianniu',
  'digital_employees.type.18': 'WeChat Official Phone',
  'digital_employees.type.19': 'RedBook Group Siphon',

  'digital_employees.status.init': 'Init',
  'digital_employees.status.op_too_frequent': 'Too frequent',
  'digital_employees.status.login': 'Logged in',
  'digital_employees.status.captcha': 'Captcha',
  'digital_employees.status.account_exception': 'Account exception',
  'digital_employees.status.exception': 'Device exception',
  'digital_employees.status.account_rest': 'Account rest',
  'digital_employees.status.task': 'Task in progress',
  'digital_employees.status.need_clear_data': 'Needs cleanup',
  'digital_employees.status.account_restricted': 'Account restricted',
  'digital_employees.status.unknown': 'Unknown',

  'digital_employees.login.yes': 'Logged in',
  'digital_employees.login.no': 'Not logged in',
  'digital_employees.available.yes': 'Available',
  'digital_employees.available.no': 'Unavailable',
  'digital_employees.mode.otg': 'OTG',
  'digital_employees.mode.usb': 'USB',

  'digital_employees.action.mirror': 'Mirror',
  'digital_employees.action.remove': 'Remove',

  'digital_employees.batch.selected': 'Selected {count} items',
  'digital_employees.batch.delete': 'Batch Delete',
  'digital_employees.batch.delete_confirm_title': 'Confirm batch delete?',
  'digital_employees.batch.delete_confirm_description': 'This will permanently delete {count} digital employees.',
  'digital_employees.refresh': 'Refresh',

  'digital_employees.filters.name_placeholder': 'Name',
  'digital_employees.filters.status_placeholder': 'Status',
  'digital_employees.filters.status_all': 'All statuses',
  'digital_employees.filters.type_placeholder': 'Business Type',
  'digital_employees.filters.type_all': 'All business types',


  'digital_employees.pagination.total': 'Total {count}',
  'digital_employees.pagination.page_size': 'Page size',
  'digital_employees.pagination.per_page': '{count} per page',
  'digital_employees.pagination.prev': 'Previous',
  'digital_employees.pagination.next': 'Next',
  'digital_employees.pagination.page': 'Page {page} / {total}',
  'digital_employees.add': 'Add digital employee',
  'digital_employees.dialog.title': 'Add digital employee',
  'digital_employees.dialog.title_edit': 'Update device',
  'digital_employees.dialog.description': 'Create a device-backed digital employee for your workspace.',
  'digital_employees.dialog.submit': 'Create',
  'digital_employees.dialog.submit_update': 'Update',
  'digital_employees.dialog.creating': 'Creating…',
  'digital_employees.dialog.updating': 'Updating…',
  'digital_employees.dialog.cancel': 'Cancel',
  'digital_employees.dialog.fields.serial_number': 'Serial number',
  'digital_employees.dialog.fields.area': 'Device area',
  'digital_employees.dialog.fields.area_placeholder': 'Select a device area',
  'digital_employees.dialog.fields.device_mode': 'Device mode',
  'digital_employees.dialog.fields.device_mode_otg': 'OTG',
  'digital_employees.dialog.fields.device_mode_usb': 'USB',
  'digital_employees.dialog.fields.forward_port': 'Forward port',
  'digital_employees.dialog.fields.remark': 'Remark',
  'digital_employees.dialog.fields.available': 'Available',
  'digital_employees.dialog.fields.available_on': 'Available',
  'digital_employees.dialog.fields.available_off': 'Unavailable',
  'digital_employees.dialog.fields.tags': 'Tags',
  'digital_employees.dialog.fields.tags_placeholder': 'Space-separated tags (e.g. test KOL)',
  'digital_employees.toast.create_success': 'Mobile employee created',
  'digital_employees.toast.update_success': 'Device updated',
  'digital_employees.toast.delete_success': 'Mobile employee removed',
  'digital_employees.toast.create_error': 'Could not create digital employee',
  'digital_employees.toast.update_error': 'Could not update device',
  'digital_employees.toast.delete_error': 'Could not remove digital employee',
  'digital_employees.delete_confirm_title': 'Confirm delete?',
  'digital_employees.delete_confirm_description': 'This will permanently delete {name} ({id}), this action cannot be undone.',
}

const marketplacePage = {
  'marketplace.title': 'App Store',
  'marketplace.description': 'Manage your apps.',
  'marketplace.searchPlaceholder': 'Search apps...',
  'marketplace.searchClear': 'Clear search',
  'marketplace.categoryPlaceholder': 'Category',
  'marketplace.category.all': 'All Categories',
  'marketplace.refresh': 'Refresh',
  'marketplace.retry': 'Retry',
  'marketplace.loadError.title': 'Failed to load apps',
  'marketplace.loadError.description': 'Please check your connection and try again.',
  'marketplace.empty.title': 'No apps found',
  'marketplace.empty.description': 'Try adjusting your search keywords or category filters.',
  'marketplace.premium': 'Premium Apps',
  'marketplace.viewDetail': 'View Details',
  'marketplace.download': 'Download',
  'marketplace.download.missing': 'Download not available for this app.',
  'marketplace.download.unsupported': 'Download not supported on current platform.',
  'marketplace.download.started': 'Download started',
  'marketplace.launch': 'Open',
  'marketplace.login': 'Login',
  'marketplace.goExternal': 'Go',
  'marketplace.launch.toast': 'Opening: {name}',
  'marketplace.details.summary': 'Summary',
  'marketplace.details.features': 'Features',

  'marketplace.category.AIGC': 'AIGC',
  'marketplace.category.KOL': 'KOL Mining',
  'marketplace.category.Flow': 'Workflow',
  'marketplace.category.Shop': 'E-commerce Tools',
  'marketplace.category.Common': 'Common Tools',
  'marketplace.category.quntool': 'Private Domain Tools',

  'marketplace.plateType.AIGC': 'AIGC',
  'marketplace.plateType.KOL': 'KOL Mining',
  'marketplace.plateType.Flow': 'Workflow',
  'marketplace.plateType.Shop': 'E-commerce Tools',
  'marketplace.plateType.Common': 'Common Tools',
  'marketplace.plateType.quntool': 'Private Domain Tools',

  'marketplace.plate.1': 'Customer Acquisition',
  'marketplace.plate.2': 'Private Domain Operations',
}

const workflowsPage = {
  'workflows.title': 'Workflows',
  'workflows.description': 'Manage your workflows.',
  'workflows.search.placeholder': 'Search all workflows',
  'workflows.nav.backToAllGroups': 'Back to All Groups',
  'workflows.nav.addGroup': 'Add Group',
  'workflows.nav.createWorkflow': 'Create Workflow',
  'workflows.section.myGroups': 'My Groups',
  'workflows.empty.noGroups': 'No groups',
  'workflows.empty.noGroupsDesc': 'Create a group to manage workflows here',
  'workflows.empty.noWorkflows': 'No workflows',
  'workflows.empty.noWorkflowsDesc': 'Create a new workflow to get started',
  'workflows.defaultGroup.title': 'Default Group',
  'workflows.defaultGroup.desc': 'Show ungrouped workflows',
  'workflows.defaultName.group': 'New Group',
  'workflows.defaultName.workflow': 'Workflow',
  'workflows.toast.createGroupFailed': 'Failed to create group',
  'workflows.toast.updateGroupFailed': 'Failed to update group',
  'workflows.toast.emptyGroupSuccess': 'Group disbanded successfully',
  'workflows.toast.emptyGroupFailed': 'Failed to disband group',
  'workflows.toast.deleteGroupSuccess': 'Deleted successfully',
  'workflows.toast.deleteGroupFailed': 'Failed to delete group',
  'workflows.toast.createWorkflowFailed': 'Failed to create workflow',
  'workflows.toast.saveSuccess': 'Saved successfully',
  'workflows.toast.saveFailed': 'Failed to save',
  'workflows.toast.lockedSuccess': 'Locked successfully',
  'workflows.toast.unlockedSuccess': 'Unlocked successfully',
  'workflows.toast.operationFailed': 'Operation failed',
  'workflows.toast.copySuccess': 'Copied successfully',
  'workflows.toast.copyFailed': 'Failed to copy',
  'workflows.toast.deleteSuccess': 'Deleted successfully',
  'workflows.toast.deleteFailed': 'Failed to delete',
  'workflows.action.move': 'Move to Group',
  'workflows.action.lock': 'Lock',
  'workflows.action.unlock': 'Unlock',
  'workflows.action.editInfo': 'Edit Info',
  'workflows.action.copy': 'Copy Workflow',
  'workflows.action.delete': 'Delete Workflow',
  'workflows.action.deleteGroup': 'Delete Group',
  'workflows.action.disbandGroup': 'Disband Group',
  'workflows.action.editWorkflow': 'Edit Workflow',
  'workflows.action.save': 'Save',
  'workflows.action.saving': 'Saving...',
  'workflows.action.cancel': 'Cancel',
  'workflows.label.name': 'Workflow Name',
  'workflows.label.desc': 'Workflow Description (Optional)',
  'workflows.label.group': 'Select Group (Optional)',
  'workflows.label.avatar': 'Workflow Icon (Optional)',
  'workflows.placeholder.input': 'Please enter',
  'workflows.placeholder.select': 'Please select',
  'workflows.placeholder.avatarUrl': 'Please enter icon URL',
  'workflows.unnamed': 'Unnamed Workflow',
  'workflows.noDescription': 'No description',
  'workflows.status.locked': 'Locked',
  'workflows.status.effective': 'Effective',
  'workflows.status.ineffective': 'Ineffective',
  'workflows.toast.nameRequired': 'Please enter workflow name',
  'workflows.count': '{count} workflow(s)',
  'workflows.group.default': 'Default Group',
  'workflows.toast.moveFailed': 'Failed to move',
	  'workflows.toast.moveSuccess': 'Moved successfully',
  'workflows.confirm.emptyGroupTitle': 'Are you sure you want to disband this group?',
  'workflows.confirm.emptyGroupDesc': 'After disbanding, resources in the group will become ungrouped',
  'workflows.confirm.deleteGroupTitle': 'Are you sure you want to delete this group?',
  'workflows.confirm.deleteGroupDesc': 'This action cannot be undone. Please proceed with caution!',
  'workflows.confirm.deleteWorkflowTitle': 'Are you sure you want to delete this workflow?',
  'workflows.confirm.deleteWorkflowDesc': 'After deletion, references in related software scenarios will become invalid.',
  'workflows.editor.backToList': 'Back to workflow list',
  'workflows.editor.missingId': 'Missing workflow ID, cannot open editor',
}

const advancedPage = {
  'advanced.page.title': 'Advanced',
  'advanced.page.description': 'Tools and utilities for power users',

  'advanced.rebuild.title': 'Rebuild Vectors',
  'advanced.rebuild.description': 'Rebuild vectors for your content. Use this when switching embedding models or to fix corrupted vectors.',
  'advanced.rebuild.mode.label': 'Rebuild Mode',
  'advanced.rebuild.mode.existing.label': 'Existing Only',
  'advanced.rebuild.mode.all.label': 'All',
  'advanced.rebuild.mode.existing.description': 'Re-embed sources, notes, and insights that already have vectors; knowledge graph entities also repair missing vectors',
  'advanced.rebuild.mode.all.description': 'Re-embed existing items + create vectors for items without them (slower, more comprehensive)',
  'advanced.rebuild.include.label': 'Rebuild Scope',
  'advanced.rebuild.include.sources': 'Sources',
  'advanced.rebuild.include.notes': 'Notes',
  'advanced.rebuild.include.insights': 'Insights',
  'advanced.rebuild.include.graph_entities': 'Knowledge graph entities',
  'advanced.rebuild.include.error': 'Please select at least one item type to rebuild',
  'advanced.rebuild.cta.loading': 'Starting rebuild...',
  'advanced.rebuild.cta.default': 'Start Rebuild',
  'advanced.rebuild.start_error': 'Failed to start rebuild: {message}',
  'advanced.rebuild.unknown_error': 'Unknown error',
  'advanced.rebuild.status.queued': 'Queued',
  'advanced.rebuild.status.running': 'Running...',
  'advanced.rebuild.status.completed': 'Completed!',
  'advanced.rebuild.status.failed': 'Failed',
  'advanced.rebuild.status.running_description': 'You can leave this page, the rebuild will run in the background',
  'advanced.rebuild.cta.new': 'Start New Rebuild',
  'advanced.rebuild.progress.label': 'Progress',
  'advanced.rebuild.progress.stats': '{processed}/{total} items ({percent}%)',
  'advanced.rebuild.progress.failed': '⚠️ {count} items failed',
  'advanced.rebuild.stats.time': 'Time',
  'advanced.rebuild.stats.started': 'Started',
  'advanced.rebuild.stats.completed': 'Completed',
  'advanced.rebuild.help.when.trigger': 'When should I rebuild vectors?',
  'advanced.rebuild.help.when.title': 'You should rebuild vectors when:',
  'advanced.rebuild.help.when.item1.title': 'Switching embedding models:',
  'advanced.rebuild.help.when.item1.description': 'If you switch from one embedding model to another, you need to rebuild all vectors to ensure consistency.',
  'advanced.rebuild.help.when.item2.title': 'Upgrading model versions:',
  'advanced.rebuild.help.when.item2.description': 'When updating to a new version of an embedding model, rebuild to take advantage of improvements.',
  'advanced.rebuild.help.when.item3.title': 'Fixing corrupted vectors:',
  'advanced.rebuild.help.when.item3.description': 'If you suspect some vectors are corrupted or missing, a rebuild can restore them.',
  'advanced.rebuild.help.when.item4.title': 'After bulk import:',
  'advanced.rebuild.help.when.item4.description': 'If you imported content without vectors, use "All" mode to embed everything.',
  'advanced.rebuild.help.time.trigger': 'How long does a rebuild take?',
  'advanced.rebuild.help.time.title': 'Processing time depends on:',
  'advanced.rebuild.help.time.item1': 'Number of items to process',
  'advanced.rebuild.help.time.item2': 'Embedding model speed',
  'advanced.rebuild.help.time.item3': 'API rate limits (for cloud providers)',
  'advanced.rebuild.help.time.item4': 'System resources',
  'advanced.rebuild.help.time.rates_title': 'Typical rates:',
  'advanced.rebuild.help.time.rate1.title': 'Local models',
  'advanced.rebuild.help.time.rate1.description': '(Ollama): Very fast, limited only by hardware',
  'advanced.rebuild.help.time.rate2.title': 'Cloud APIs',
  'advanced.rebuild.help.time.rate2.description': '(OpenAI, Google): Moderate speed, may hit rate limits with large datasets',
  'advanced.rebuild.help.time.rate3.title': 'Sources:',
  'advanced.rebuild.help.time.rate3.description': 'Slower than notes/insights (multiple chunks created per source)',
  'advanced.rebuild.help.time.example': 'Example: Rebuilding 200 items with Cloud API might take 2-5 minutes, less than 1 minute with local models.',
  'advanced.rebuild.help.safe.trigger': 'Is it safe to rebuild while using the app?',
  'advanced.rebuild.help.safe.title': 'Yes, rebuilding is safe!',
  'advanced.rebuild.help.safe.item1.title': 'Idempotent:',
  'advanced.rebuild.help.safe.item1.description': 'Running multiple times produces the same result',
  'advanced.rebuild.help.safe.item2.title': 'Non-destructive:',
  'advanced.rebuild.help.safe.item2.description': 'Only replaces vectors',
  'advanced.rebuild.help.safe.item3.title': 'Run anytime:',
  'advanced.rebuild.help.safe.item3.description': 'No need to stop other operations',
  'advanced.rebuild.help.safe.item4.title': 'Graceful error handling:',
  'advanced.rebuild.help.safe.item4.description': 'Failed items are logged and skipped',
  'advanced.rebuild.help.safe.warning.title': 'However:',
  'advanced.rebuild.help.safe.warning.description': 'Very large rebuilds (thousands of items) might temporarily slow down search during processing.',

  'advanced.system_info.title': 'System Info',
  'advanced.system_info.loading': 'Loading...',
  'advanced.system_info.current_version': 'Current Version',
  'advanced.system_info.unknown': 'Unknown',
  'advanced.system_info.latest_version': 'Latest Version',
  'advanced.system_info.status': 'Status',
  'advanced.system_info.update_available': 'Update Available',
  'advanced.system_info.up_to_date': 'Up to Date',
  'advanced.system_info.view_on_website': 'View on Website',
  'advanced.system_info.update_check_failed': 'Failed to check for updates. Update server may be unreachable.',

  'advanced.desktop_runtime.title': 'Desktop Runtime',
  'advanced.desktop_runtime.description': 'Manage local desktop backend and sidecar services',
  'advanced.desktop_runtime.backend': 'Backend Process',
  'advanced.desktop_runtime.runtime': 'Python Runtime',
  'advanced.desktop_runtime.sidecars': 'Sidecar Services',
  'advanced.desktop_runtime.healthy': 'Healthy',
  'advanced.desktop_runtime.unhealthy': 'Unhealthy',
  'advanced.desktop_runtime.not_configured': 'Not Configured',
  'advanced.desktop_runtime.pid': 'PID',
  'advanced.desktop_runtime.restart_backend': 'Restart Backend',
  'advanced.desktop_runtime.start_runtime': 'Start Runtime',
  'advanced.desktop_runtime.stop_runtime': 'Stop Runtime',
  'advanced.desktop_runtime.start_sidecars': 'Start Sidecars',
  'advanced.desktop_runtime.stop_sidecars': 'Stop Sidecars',
  'advanced.desktop_runtime.diagnostics': 'Diagnostics',
  'advanced.desktop_runtime.export_diagnostics': 'Export Diagnostics',
  'advanced.desktop_runtime.exported_path': 'Exported file',
  'advanced.desktop_runtime.total_errors': 'Total Errors',
  'advanced.desktop_runtime.fault.title': 'Startup Fault Detected',
  'advanced.desktop_runtime.recheck': 'Recheck',
  'advanced.desktop_runtime.error_code.BACKEND_START_FAILED': 'BACKEND_START_FAILED',
  'advanced.desktop_runtime.error_code.RUNTIME_START_FAILED': 'RUNTIME_START_FAILED',
  'advanced.desktop_runtime.error_code.SIDECAR_NOT_CONFIGURED': 'SIDECAR_NOT_CONFIGURED',
  'advanced.desktop_runtime.error_code.PORT_CONFLICT': 'PORT_CONFLICT',
  'advanced.desktop_runtime.error_code.UNKNOWN': 'UNKNOWN',
  'advanced.desktop_runtime.error_hint.port_conflict.1': 'A required local port may already be occupied by another process.',
  'advanced.desktop_runtime.error_hint.port_conflict.2': 'Stop conflicting processes or change desktop ports, then retry startup.',
  'advanced.desktop_runtime.error_hint.backend_failed.1': 'Desktop Python backend failed to start or exited early.',
  'advanced.desktop_runtime.error_hint.backend_failed.2': 'Check Python environment and rerun after exporting diagnostics.',
  'advanced.desktop_runtime.error_hint.runtime_failed.1': 'Runtime service startup did not reach healthy state in time.',
  'advanced.desktop_runtime.error_hint.runtime_failed.2': 'Check sidecar commands, logs and dependencies, then restart runtime.',
  'advanced.desktop_runtime.error_hint.sidecar_config.1': 'PostgreSQL/Redis sidecar startup commands are not configured.',
  'advanced.desktop_runtime.error_hint.sidecar_config.2': 'Set DESKTOP_POSTGRES_COMMAND / DESKTOP_REDIS_COMMAND in desktop env.',
  'advanced.desktop_runtime.error_hint.unknown.1': 'An unknown startup error was detected.',
  'advanced.desktop_runtime.error_hint.unknown.2': 'Export diagnostics and inspect runtime and service logs for details.',

  'advanced.jobs.title': 'Job Queue',
  'advanced.jobs.description': 'Monitor background tasks and jobs',
  'advanced.jobs.empty': 'No jobs',
  'advanced.jobs.columns.status': 'Status',
  'advanced.jobs.columns.type': 'Type',
  'advanced.jobs.columns.details': 'Details',
  'advanced.jobs.columns.created': 'Created',
  'advanced.jobs.columns.started': 'Started',
  'advanced.jobs.columns.duration': 'Duration',
  'advanced.jobs.total': 'Total: {count}',
  'advanced.jobs.columns.actions': 'Actions',
  'advanced.jobs.actions.retry': 'Retry',
  'advanced.jobs.actions.sourceDeleted': 'Document deleted, cannot retry',
  'advanced.jobs.status.new': 'New',
  'advanced.jobs.status.running': 'Running',
  'advanced.jobs.status.completed': 'Completed',
  'advanced.jobs.status.failed': 'Failed',
  'advanced.jobs.status.canceled': 'Canceled',
  'advanced.jobs.source_filter_placeholder': 'Filter by source',
  'advanced.jobs.all_sources': 'All Sources',
}

const sourceCard = {
  'sourceCard.status.new.label': 'New',
  'sourceCard.status.new.description': 'Source created',
  'sourceCard.status.queued.label': 'Queued',
  'sourceCard.status.queued.description': 'Waiting for processing',
  'sourceCard.status.running.label': 'Processing',
  'sourceCard.status.running.description': 'Processing content',
  'sourceCard.status.completed.label': 'Completed',
  'sourceCard.status.completed.description': 'Processing complete',
  'sourceCard.status.failed.label': 'Failed',
  'sourceCard.status.failed.description': 'Processing failed',
  'sourceCard.untitled': 'Untitled Source',
  'sourceCard.checking': 'Checking status...',
  'sourceCard.type.link': 'Link',
  'sourceCard.type.upload': 'File',
  'sourceCard.type.text': 'Text',
  'sourceCard.type.unknown': 'Unknown',
  'sourceCard.insights': '{count} insights',
  'sourceCard.moreTopics': '+{count} more',
  'sourceCard.actions.removeFromNotebook': 'Remove from Notebook',
  'sourceCard.actions.retry': 'Retry Processing',
  'sourceCard.actions.rebuildVectorFailed': 'Rebuild Failed Vector Tasks',
  'sourceCard.actions.rebuildGraphFailed': 'Rebuild Failed Graph Tasks',
  'sourceCard.actions.delete': 'Delete Source',
  'sourceCard.rebuild.vector.loading': 'Rebuilding vectors...',
  'sourceCard.rebuild.vector.success': 'Vector tasks queued for rebuild',
  'sourceCard.rebuild.vector.error': 'Failed to rebuild vector tasks',
  'sourceCard.rebuild.graph.loading': 'Rebuilding graph...',
  'sourceCard.rebuild.graph.success': 'Graph tasks queued for rebuild',
  'sourceCard.rebuild.graph.error': 'Failed to rebuild graph tasks',
  'sourceCard.progress': 'Vector Index Build Progress',
  'sourceCard.embed': 'Embed',
  'sourceCard.graphrag': 'Graph',
  'sourceCard.graphragProgress': 'Knowledge Graph Index Build Progress',
}

const sourceDetail = {
  'sourceDetail.error.load': 'Failed to load source details',
  'sourceDetail.success.insightCreated': 'Insight created successfully',
  'sourceDetail.error.createInsight': 'Failed to create insight',
  'sourceDetail.success.titleUpdated': 'Source title updated',
  'sourceDetail.error.updateTitle': 'Failed to update source title',
  'sourceDetail.error.embed': 'Failed to embed content',
  'sourceDetail.success.downloadStarted': 'Download started',
  'sourceDetail.error.fileUnavailable': 'Original file is no longer available on server',
  'sourceDetail.error.download': 'Failed to download file',
  'sourceDetail.success.urlCopied': 'URL copied to clipboard',
  'sourceDetail.confirm.delete': 'Are you sure you want to delete this source?',
  'sourceDetail.success.delete': 'Source deleted successfully',
  'sourceDetail.error.delete': 'Failed to delete source',
  'sourceDetail.notFound': 'Source not found',
  'sourceDetail.title.placeholder': 'Source Title',
  'sourceDetail.title.untitled': 'Untitled Source',
  'sourceDetail.sourceId': 'Source ID: {id}',
  'sourceDetail.chat': 'Chat with Source',
  'sourceDetail.file.unavailable': 'File Unavailable',
  'sourceDetail.file.preparing': 'Preparing download...',
  'sourceDetail.file.download': 'Download File',
  'sourceDetail.embed.embedding': 'Building Vector Index...',
  'sourceDetail.embed.alreadyEmbedded': 'Vector Index Built',
  'sourceDetail.embed.action': 'Build Vector Index',
  'sourceDetail.delete': 'Delete Source',
  'sourceDetail.tabs.content': 'Content',
  'sourceDetail.tabs.images': 'Images',
  'sourceDetail.tabs.insights': 'Insights',
  'sourceDetail.tabs.details': 'Details',
  'sourceDetail.youtube.open': 'Open on YouTube',
  'sourceDetail.content.empty': 'No content',
  'sourceDetail.images.description': 'Images extracted from PDF and uploaded to COS',
  'sourceDetail.images.empty': 'No parsed images',
  'sourceDetail.images.open': 'Open',
  'sourceDetail.images.page': 'Page',
  'sourceDetail.images.item': 'Image',
  'sourceDetail.insights.description': 'AI-generated insights about this source',
  'sourceDetail.insights.generate': 'Generate New Insight',
  'sourceDetail.insights.creating': 'Creating...',
  'sourceDetail.insights.selectSkill': 'Select a skill...',
  'sourceDetail.error.selectSkill': 'Please select a skill',
  'sourceDetail.insights.create': 'Create',
  'sourceDetail.insights.empty.title': 'No insights yet',
  'sourceDetail.insights.view': 'View Insight',
  'sourceDetail.insights.confirmDeleteTitle': 'Delete this insight?',
  'sourceDetail.insights.confirmDeleteDescription': 'This action cannot be undone.',
  'sourceDetail.alert.notEmbedded.title': 'Content Not Indexed',
  'sourceDetail.alert.notEmbedded.description': 'This content has not been indexed for vector search. Building the index enables advanced search capabilities and better content discovery.',
  'sourceDetail.alert.graphNotBuilt.title': 'Knowledge Graph Not Built',
  'sourceDetail.alert.graphNotBuilt.description': 'This content has not been processed for knowledge graph (GraphRAG). Building the graph enables deeper entity relationship analysis and complex Q&A.',
  'sourceDetail.graphrag.building': 'Building...',
  'sourceDetail.graphrag.alreadyBuilt': 'Graph Built',
  'sourceDetail.graphrag.action': 'Build Knowledge Graph',
  'sourceDetail.graphrag.progress': 'Graph Build Progress',
  'sourceDetail.graphrag.failed': '{count} failed tasks',
  'sourceDetail.error.buildGraph': 'Failed to build knowledge graph',
  'sourceDetail.url': 'URL',
  'sourceDetail.uploadedFile': 'Uploaded File',
  'sourceDetail.file.unavailableButton': 'Unavailable',
  'sourceDetail.file.preparingButton': 'Preparing...',
  'sourceDetail.file.downloadButton': 'Download',
  'sourceDetail.file.unavailableDescription': 'The original file is no longer available on the server (likely deleted after processing). Upload again if you need a fresh copy.',
  'sourceDetail.topics': 'Topics',
  'sourceDetail.metadata': 'Metadata',
  'sourceDetail.metadata.embedded': 'Vector Index Built',
  'sourceDetail.metadata.notEmbedded': 'Vector Index Not Built',
  'sourceDetail.metadata.graphBuilt': 'Graph Built',
  'sourceDetail.metadata.graphNotBuilt': 'Graph Not Built',
  'sourceDetail.metadata.entityCount': '{count} entities',
  'sourceDetail.metadata.created': 'Created',
  'sourceDetail.metadata.updated': 'Updated',
  'sourceDetail.type.unknown': 'Unknown',
  'sourceDetail.type.link': 'Link',
  'sourceDetail.type.file': 'File',
  'sourceDetail.type.text': 'Text',
}

const streamingResponse = {
  'streamingResponse.error.notFound': 'This {type} could not be found',
  'streamingResponse.ariaLabel': 'Ask response',
  'streamingResponse.strategy.title': 'Strategy',
  'streamingResponse.strategy.reasoning': 'Reasoning:',
  'streamingResponse.strategy.searchTerms': 'Search Terms:',
  'streamingResponse.individualAnswers': 'Individual Answers ({count})',
  'streamingResponse.finalAnswer': 'Final Answer',
  'streamingResponse.processing': 'Processing your question...',
}

const advancedModelsDialog = {
  'advancedModelsDialog.title': 'Advanced Model Selection',
  'advancedModelsDialog.description': 'Select specific models for each stage of the asking process',
  'advancedModelsDialog.strategyModel.label': 'Strategy Model',
  'advancedModelsDialog.strategyModel.placeholder': 'Select strategy model',
  'advancedModelsDialog.answerModel.label': 'Answer Model',
  'advancedModelsDialog.answerModel.placeholder': 'Select answer model',
  'advancedModelsDialog.finalAnswerModel.label': 'Final Answer Model',
  'advancedModelsDialog.finalAnswerModel.placeholder': 'Select final answer model',
  'advancedModelsDialog.cancel': 'Cancel',
  'advancedModelsDialog.save': 'Save Changes',
}

const saveToNotebooksDialog = {
  'saveToNotebooksDialog.title': 'Save to Notebooks',
  'saveToNotebooksDialog.description': 'Select one or more notebooks to save this answer',
  'saveToNotebooksDialog.error.selectNotebook': 'Please select at least one notebook',
  'saveToNotebooksDialog.success.saved': 'Answer saved to {count} notebooks',
  'saveToNotebooksDialog.error.saveFailed': 'Failed to save answer',
  'saveToNotebooksDialog.empty': 'No notebooks found. Please create a notebook first.',
  'saveToNotebooksDialog.cancel': 'Cancel',
  'saveToNotebooksDialog.saving': 'Saving...',
  'saveToNotebooksDialog.save': 'Save to {count} Notebooks',
}

const modelsToast = {
  'models.toast.create.success.title': 'Success',
  'models.toast.create.success.description': 'Model created successfully',
  'models.toast.create.success.description_with_dim': 'Model created successfully (Detected vector dimension: {dim})',
  'models.toast.create.error.title': 'Error',
  'models.toast.create.error.description': 'Failed to create model',
  'models.toast.delete.success.title': 'Success',
  'models.toast.delete.success.description': 'Model deleted successfully',
  'models.toast.delete.error.title': 'Error',
  'models.toast.delete.error.description': 'Failed to delete model',
  'models.toast.updateDefaults.success.title': 'Success',
  'models.toast.updateDefaults.success.description': 'Default models updated successfully',
  'models.toast.updateDefaults.error.title': 'Error',
  'models.toast.updateDefaults.error.description': 'Failed to update default models',
  'models.toast.updateProviderSettings.success.title': 'Success',
  'models.toast.updateProviderSettings.success.description': 'Provider settings updated successfully',
  'models.toast.updateProviderSettings.error.title': 'Error',
  'models.toast.updateProviderSettings.error.description': 'Failed to update provider settings',
}

const xhsqunToast = {
  'xhsqun.autojoin.toast.selectWorkflow': 'Please select a workflow',
  'xhsqun.autojoin.toast.invalidDailyJoinLimit': 'Initial daily join limit cannot be greater than or equal to the final limit',
  'xhsqun.autojoin.toast.saveFailed': 'Failed to save',
  'xhsqun.autojoin.toast.selectDeviceGroup': 'Please select a device group',
  'xhsqun.autojoin.toast.saveSuccess': 'Saved successfully',
  'xhsqun.autojoin.toast.operationFailed': 'Operation failed',
  'xhsqun.autojoin.toast.deviceIdCopied': 'Device ID copied',
  'xhsqun.autojoin.toast.copyFailed': 'Copy failed',
  'xhsqun.autojoin.toast.invalidGroupSizeLimit': 'Group size lower limit cannot be greater than or equal to the upper limit',
  'xhsqun.autojoin.toast.stopSuccess': 'Task stopped successfully',
  'xhsqun.autojoin.toast.startSuccess': 'Task started successfully',
  'xhsqun.autojoin.toast.loadFailed': 'Failed to load',
  'xhsqun.autojoin.toast.operationSuccess': 'Operation successful',
}

const dykolToast = {
  'dykol.deviceGroups.toast.createSuccess': 'Created successfully',
  'dykol.deviceGroups.toast.createFailed': 'Failed to create',
  'dykol.deviceGroups.toast.updateSuccess': 'Updated successfully',
  'dykol.deviceGroups.toast.updateFailed': 'Failed to update',
  'dykol.deviceGroups.toast.deleteSuccess': 'Deleted successfully',
  'dykol.deviceGroups.toast.deleteFailed': 'Failed to delete',
  'dykol.deviceGroups.toast.enterGroupName': 'Please enter group name',
  'dykol.task.toast.createSuccess': 'Task created successfully',
  'dykol.task.toast.createFailed': 'Failed to create task',
}

const xhsqunPrivateToast = {
  'xhsqun.private.toast.saveSuccess': 'Saved successfully',
  'xhsqun.private.toast.saveFailed': 'Failed to save',
  'xhsqun.private.toast.selectWorkflow': 'Please select a workflow',
  'xhsqun.private.toast.loadFailed': 'Failed to load',
  'xhsqun.private.toast.operationFailed': 'Operation failed',
  'xhsqun.private.toast.paused': 'Paused',
  'xhsqun.private.toast.resumed': 'Resumed',
  'xhsqun.private.toast.deviceIdCopied': 'Device ID copied',
  'xhsqun.private.toast.copyFailed': 'Copy failed',
}

const emailTemplateToast = {
  'email.template.toast.deleteSuccess': 'Deleted successfully',
  'email.template.toast.deleteFailed': 'Failed to delete',
  'email.template.toast.createHint': 'Template creation page not yet migrated, please create in the old system.',
  'email.template.toast.editHint': 'Template edit page not yet migrated, please edit in the old system.',
}

const emailRenewToast = {
  'email.renew.toast.purchaseSuccess': 'Purchase successful',
  'email.renew.toast.purchaseFailed': 'Purchase failed',
  'email.renew.toast.statusUpdateSuccess': 'Status updated successfully',
  'email.renew.toast.statusUpdateFailed': 'Failed to update status',
  'email.renew.toast.enterSearchKeyword': 'Please enter search keyword',
  'email.renew.toast.searchFailed': 'Search failed',
  'email.renew.toast.selectDomain': 'Please select a domain to purchase',
  'email.renew.toast.rechargeHint': 'Recharge portal not yet migrated, please go to the old system.',
  'email.renew.toast.enterPurchaseQuantity': 'Purchase quantity cannot be empty',
}

const gnkeyToast = {
  'gnkey.page.toast.loadFailed': 'Failed to load',
  'gnkey.page.toast.deleteSuccess': 'Deleted successfully',
  'gnkey.page.toast.deleteFailed': 'Failed to delete',
  'gnkey.create.toast.openSuccess': 'Opened successfully',
  'gnkey.create.toast.openFailed': 'Failed to open',
  'gnkey.create.toast.noSceneId': 'No sceneId returned',
}

const emailCustomerToast = {
  'email.customer.toast.addSuccess': 'Added successfully',
  'email.customer.toast.addFailed': 'Failed to add',
  'email.customer.toast.updateSuccess': 'Updated successfully',
  'email.customer.toast.updateFailed': 'Failed to update',
  'email.customer.toast.deleteSuccess': 'Deleted successfully',
  'email.customer.toast.deleteFailed': 'Failed to delete',
  'email.customer.toast.cleanSuccess': 'Email cleaning successful',
  'email.customer.toast.cleanFailed': 'Email cleaning failed',
  'email.customer.toast.importSuccess': 'Import successful',
  'email.customer.toast.importFailed': 'Import failed',
  'email.customer.toast.enterName': 'Please enter name',
  'email.customer.toast.selectFile': 'Please select a file to upload',
  'email.customer.toast.noEmailsToClean': 'No emails to clean in the current form.',
  'email.customer.toast.insufficientQuota': 'Insufficient cleaning quota, please purchase in renewal management.',
  'email.customer.toast.createTaskHint': 'Task creation page not yet migrated, please create in the old system.',
}

const emailTaskToast = {
  'email.task.toast.info': 'Info',
  'email.task.toast.updateFailed': 'Update failed',
  'email.task.toast.deleteSuccess': 'Deleted successfully',
  'email.task.toast.deleteFailed': 'Failed to delete',
  'email.task.toast.createHint': 'Task creation page not yet migrated, please create in the old system.',
  'email.task.toast.detailHint': 'Task detail page not yet migrated, please view in the old system.',
  'email.task.toast.editHint': 'Task edit page not yet migrated, please edit in the old system.',
}

const workflowsToast = {
  'workflows.toast.createGroupFailed': 'Failed to create group',
  'workflows.toast.updateGroupFailed': 'Failed to update group',
  'workflows.toast.emptyGroupSuccess': 'Group disbanded successfully',
  'workflows.toast.emptyGroupFailed': 'Failed to disband group',
  'workflows.toast.deleteGroupSuccess': 'Deleted successfully',
  'workflows.toast.deleteGroupFailed': 'Failed to delete group',
  'workflows.toast.createWorkflowFailed': 'Failed to create workflow',
  'workflows.toast.saveSuccess': 'Saved successfully',
  'workflows.toast.saveFailed': 'Failed to save',
  'workflows.toast.lockedSuccess': 'Locked successfully',
  'workflows.toast.unlockedSuccess': 'Unlocked successfully',
  'workflows.toast.operationFailed': 'Operation failed',
  'workflows.toast.copySuccess': 'Copied successfully',
  'workflows.toast.copyFailed': 'Failed to copy',
  'workflows.toast.deleteSuccess': 'Deleted successfully',
  'workflows.toast.deleteFailed': 'Failed to delete',
  'workflows.toast.moveFailed': 'Failed to move',
  'workflows.toast.moveSuccess': 'Moved successfully',
}

const gzhkolMonitorToast = {
  'gzhkol.monitor.toast.loadFailed': 'Failed to load',
  'gzhkol.monitor.toast.operationSuccess': 'Operation successful',
  'gzhkol.monitor.toast.operationFailed': 'Operation failed',
}

const gzhkolResourceToast = {
  'gzhkol.resource.toast.operationSuccess': 'Operation successful',
  'gzhkol.resource.toast.operationFailed': 'Operation failed',
  'gzhkol.resource.toast.updateSuccess': 'Updated successfully',
  'gzhkol.resource.toast.updateFailed': 'Failed to update',
  'gzhkol.resource.checkLink.toast.loadFailed': 'Failed to load',
}

const dykolTask = {
  'dykol.task.status.pending': 'Pending',
  'dykol.task.status.running': 'Running...',
  'dykol.task.status.completed': 'Completed',
  'dykol.task.status.paused': 'Paused',
  'dykol.task.time.justNow': 'Just now',
  'dykol.task.time.minutesAgo': '{minutes} mins ago',
  'dykol.task.time.minutesLater': '{minutes} mins later',
  'dykol.task.time.hoursAgo': '{hours} hours ago',
  'dykol.task.time.hoursLater': '{hours} hours later',
  'dykol.task.time.daysAgo': '{days} days ago',
  'dykol.task.time.daysLater': '{days} days later',
  'dykol.task.create.title': 'Create Task',
  'dykol.task.create.wizard': 'Task Wizard',
  'dykol.task.statistic.title': 'Task Statistics',
  'dykol.task.statistic.totalMatched': 'Total Matched',
  'dykol.task.statistic.todayMatched': 'Today Matched',
  'dykol.task.statistic.lastUpdated': 'Last Updated',
  'dykol.task.statistic.matchRate': 'Match Rate',
  'dykol.task.unit.person': 'people',
  'dykol.task.list.title': 'Mining Tasks',
  'dykol.task.list.count': 'Total Tasks {count}',
  'dykol.task.search.placeholder': 'Search task name',
  'dykol.task.filter.status': 'Status',
  'dykol.task.filter.all': 'All Status',
  'dykol.task.filter.pending': 'Pending',
  'dykol.task.filter.running': 'Running',
  'dykol.task.filter.completed': 'Completed',
  'dykol.task.filter.paused': 'Paused',
  'dykol.task.filter.clear': 'Clear',
  'dykol.task.list.loading': 'Loading...',
  'dykol.task.list.empty': 'No tasks',
  'dykol.task.list.loadingMore': 'Loading more...',
  'dykol.task.list.noMore': 'No more tasks',
  'dykol.task.toast.loadFailed': 'Load failed',
  'dykol.task.toast.deleteSuccess': 'Delete success',
  'dykol.task.toast.pauseSuccess': 'Pause success',
  'dykol.task.toast.resumeSuccess': 'Resume success',
  'dykol.task.toast.operationFailed': 'Operation failed',
  'dykol.task.action.delete': 'Delete',
  'dykol.task.action.pause': 'Pause',
  'dykol.task.action.resume': 'Resume',
  'dykol.task.confirm.deleteDescription': 'Cannot be recovered after deletion.',
  'dykol.task.confirm.actionDescription': 'Are you sure to {action} this task?',
  'dykol.task.card.status': 'Status: {status}',
  'dykol.task.card.devices': 'Using {count} devices',
  'dykol.task.card.lastMatched': 'Last matched: {time}',
  'dykol.task.card.actions': 'Actions',
  'dykol.task.card.resumeTask': 'Resume Task',
  'dykol.task.card.pauseTask': 'Pause Task',
  'dykol.task.card.deleteTask': 'Delete Task',
  'dykol.task.card.progress': 'Progress',
  'dykol.task.card.matchedCount': 'Matched',
  'dykol.task.card.collectedCount': 'Collected',
  'dykol.task.confirm.title': 'Confirm {action}',
}

const notebooksToast = {
  'notebooks.toast.create.success.title': 'Success',
  'notebooks.toast.create.success.description': 'Notebook created successfully',
  'notebooks.toast.create.error.title': 'Error',
  'notebooks.toast.create.error.description': 'Failed to create notebook',
  'notebooks.toast.update.success.title': 'Success',
  'notebooks.toast.update.success.description': 'Notebook updated successfully',
  'notebooks.toast.update.error.title': 'Error',
  'notebooks.toast.update.error.description': 'Failed to update notebook',
  'notebooks.toast.delete.success.title': 'Success',
  'notebooks.toast.delete.success.description': 'Notebook deleted successfully',
  'notebooks.toast.delete.error.title': 'Error',
  'notebooks.toast.delete.error.description': 'Failed to delete notebook',
}

const emailTaskPage = {
  'email.task.stats.totalSend': 'Total Send',
  'email.task.stats.todaySend': 'Today Send',
  'email.task.stats.todaySuccess': 'Today Reach',
  'email.task.stats.totalClick': 'Today Click',
  'email.task.stats.unit': 'people',
  'email.task.create.title': 'Create Task',
  'email.task.create.button': 'Create Task Now',
  'email.task.create.toast.title': 'Hint',
  'email.task.stats.title': 'Task Statistics',
  'email.task.list.title': 'Task List',
  'email.task.list.total': 'Total {count}',
  'email.task.filter.status.placeholder': 'Task Status',
  'email.task.filter.status.all': 'All Status',
  'email.task.filter.search.placeholder': 'Search task name',
  'email.task.filter.clear': 'Clear',
  'email.task.list.loading': 'Loading...',
  'email.task.list.empty': 'No tasks',
  'email.task.list.header.name': 'Task Name',
  'email.task.list.header.status': 'Status',
  'email.task.list.header.totalEmail': 'Total Emails',
  'email.task.list.header.cleanRate': 'Clean Rate',
  'email.task.list.header.sendProgress': 'Send Progress',
  'email.task.list.header.metrics': 'Reach/Read/Click',
  'email.task.list.header.createdAt': 'Created At',
  'email.task.list.header.actions': 'Actions',
  'email.task.metrics.reach': 'Reach',
  'email.task.metrics.read': 'Read',
  'email.task.metrics.click': 'Click',
  'email.task.delete.title': 'Delete Task',
  'email.task.delete.description': 'Task "{name}" cannot be recovered after deletion. Please proceed with caution.',
  'email.task.delete.confirm': 'Delete',
}

const notesToast = {
  'notes.toast.create.success.title': 'Success',
  'notes.toast.create.success.description': 'Note created successfully',
  'notes.toast.create.error.title': 'Error',
  'notes.toast.create.error.description': 'Failed to create note',
  'notes.toast.update.success.title': 'Success',
  'notes.toast.update.success.description': 'Note updated successfully',
  'notes.toast.update.error.title': 'Error',
  'notes.toast.update.error.description': 'Failed to update note',
  'notes.toast.delete.success.title': 'Success',
  'notes.toast.delete.success.description': 'Note deleted successfully',
  'notes.toast.delete.error.title': 'Error',
  'notes.toast.delete.error.description': 'Failed to delete note',
}


const searchToast = {
  'search.toast.error.title': 'Search failed',
  'search.toast.error.description': 'An error occurred while searching',
}

const settingsToast = {
  'settings.toast.update.success.title': 'Success',
  'settings.toast.update.success.description': 'Settings updated successfully',
  'settings.toast.update.error.title': 'Error',
  'settings.toast.update.error.description': 'Failed to update settings',
}

const sourcesToast = {
  'sources.toast.create.queued.title': 'Source Queued',
  'sources.toast.create.queued.description': 'Source submitted for background processing. You can monitor progress in the sources list.',
  'sources.toast.create.success.title': 'Success',
  'sources.toast.create.success.description': 'Source added successfully',
  'sources.toast.create.error.title': 'Error',
  'sources.toast.create.error.description': 'Failed to add source',
  'sources.toast.update.success.title': 'Success',
  'sources.toast.update.success.description': 'Source updated successfully',
  'sources.toast.update.error.title': 'Error',
  'sources.toast.update.error.description': 'Failed to update source',
  'sources.toast.delete.success.title': 'Success',
  'sources.toast.delete.success.description': 'Source deleted successfully',
  'sources.toast.delete.error.title': 'Error',
  'sources.toast.delete.error.description': 'Failed to delete source',
  'sources.toast.upload.success.title': 'Success',
  'sources.toast.upload.success.description': 'File uploaded successfully',
  'sources.toast.upload.error.title': 'Error',
  'sources.toast.upload.error.description': 'Failed to upload file',
  'sources.toast.retry.success.title': 'Source Retry Queued',
  'sources.toast.retry.success.description': 'The source has been requeued for processing.',
  'sources.toast.retry.error.title': 'Retry Failed',
  'sources.toast.retry.error.description': 'Failed to retry source processing. Please try again.',
  'sources.toast.addToNotebook.success.title': 'Success',
  'sources.toast.addToNotebook.success.description': '{count} {count, plural, one {source} other {sources}} added to notebook',
  'sources.toast.addToNotebook.error.title': 'Error',
  'sources.toast.addToNotebook.error.description': 'Failed to add sources to notebook',
  'sources.toast.addToNotebook.partial.title': 'Partial Success',
  'sources.toast.addToNotebook.partial.description': '{successes} {successes, plural, one {source} other {sources}} added, {failures} failed',
  'sources.toast.removeFromNotebook.success.title': 'Success',
  'sources.toast.removeFromNotebook.success.description': 'Source removed from notebook successfully',
  'sources.toast.removeFromNotebook.error.title': 'Error',
  'sources.toast.removeFromNotebook.error.description': 'Failed to remove source from notebook',
}


const versionCheckToast = {
  'versionCheck.toast.available.title': 'Version {version} available',
  'versionCheck.toast.available.description': 'A new version of FishOwn Agent is available.',
  'versionCheck.toast.available.action': 'View on GitHub',
}

const chatToast = {
  'chat.toast.createSession.success': 'Chat session created',
  'chat.toast.createSession.error': 'Failed to create chat session',
  'chat.toast.updateSession.success': 'Session updated',
  'chat.toast.updateSession.error': 'Failed to update session',
  'chat.toast.deleteSession.success': 'Session deleted',
  'chat.toast.deleteSession.error': 'Failed to delete session',
  'chat.toast.sendMessage.error': 'Failed to send message',
}

const commonToast = {
  'common.toast.error': 'Error',
  'common.toast.success': 'Success',
}

const skillsPage = {
  'skills.title': 'Plugins & Skills',
  'skills.subtitle': 'Manage plugins and skills.',
  'skills.tabPlugins': 'Plugins',
  'skills.tabSkills': 'Skills',
  'skills.tabPlayground': 'Playground',
  'skills.playground.title': 'Skill Playground',
  'skills.playground.description': 'Chat with your skills to test and experiment.',
  'skills.playground.skill_label': 'Skill',
  'skills.playground.skill_placeholder': 'Select a skill',
  'skills.playground.model_label': 'Model',
  'skills.playground.model_placeholder': 'Select a model',
  'skills.playground.input_placeholder': 'Type your message...',
  'skills.playground.send': 'Send',
  'skills.playground.running': 'Running {skill}...',
  'skills.playground.no_skills': 'No skills available.',
  'skills.playground.toast.error.title': 'Playground Error',
  'skills.playground.toast.error.description': 'Skill execution failed.',
  'skills.filter': 'Filter',
  'skills.searchPlaceholder': 'Search skills',
  'skills.showing': 'Showing {count} items',
  'skills.refresh': 'Refresh',
  'skills.bundled': 'System',
  'skills.loadError.title': 'Failed to load skills',
  'skills.loadError.description': 'An error occurred while retrieving the skills list from the server.',
  'skills.retry': 'Retry',
  'skills.empty.title': 'No skills found.',
  'skills.empty.description': 'Please check your configuration or try again later.',
  'skills.empty.search': 'No matching skills found.',
  'skills.source.bundled': 'Bundled',
  'skills.source.hosted': 'Hosted',
  'skills.source.workspace': 'Workspace',
  'skills.actions.enable': 'Enable',
  'skills.actions.disable': 'Disable',
  'skills.card.noDescription': 'No description',
  'skills.browseStore': 'Browse Skills Store',
  'skills.groups.workspace': 'Workspace Skills',
  'skills.groups.builtIn': 'Built-in Skills',
  'skills.groups.installed': 'Installed Skills',
  'skills.groups.extra': 'Extra Skills',
  'skills.groups.other': 'Other Skills',
  'skills.status.bundled': 'bundled',
  'skills.status.eligible': 'eligible',
  'skills.status.blocked': 'blocked',
  'skills.status.disabled': 'disabled',
  'skills.status.blockedByAllowlist': 'blocked by allowlist',
  'skills.card.missing': 'Missing: {reasons}',
  'skills.card.reason': 'Reason: {reasons}',
  'skills.actions.saveKey': 'Save key',
  'skills.apiKey': 'API key',
  'skills.installing': 'Installing…',

  // ── Workspace (SkillsWorkspace) ──
  'skills.workspace.title': 'Skills',
  'skills.workspace.availableCount': '{count} available',
  'skills.workspace.filterPlaceholder': 'Filter skills',
  'skills.workspace.noMatch': 'No skills match this filter.',
  'skills.workspace.emptyTitle': 'No skills found',
  'skills.workspace.emptyDesc': 'Create or import a skill to inspect its files.',
  'skills.workspace.selectFile': 'Select a file to inspect.',
  'skills.workspace.never': 'Never',

  // Import
  'skills.workspace.importPlaceholder': 'Paste path, GitHub URL, or skills.sh command',
  'skills.workspace.importAdd': 'Add',
  'skills.workspace.importSuccess_one': '1 skill imported',
  'skills.workspace.importSuccess_other': '{count} skills imported',
  'skills.workspace.importFailed': 'Skill import failed',

  // Source help dialog
  'skills.workspace.sourceHelpTitle': 'Add a skill source',
  'skills.workspace.sourceHelpDesc': 'Paste a local path, GitHub URL, or skills.sh command into the field first.',
  'skills.workspace.browseSkillsSh': 'Browse skills.sh',
  'skills.workspace.browseSkillsShDesc': 'Find install commands and paste one here.',
  'skills.workspace.browseSkillHub': 'Browse SkillHub',
  'skills.workspace.browseSkillHubDesc': 'Visit skillhub.cn skills store, find an install command and paste it here.',
  'skills.workspace.searchGithub': 'Search GitHub',
  'skills.workspace.searchGithubDesc': 'Look for repositories with SKILL.md, then paste the repo URL here.',

  // Delete dialog
  'skills.workspace.deleteTitle': 'Remove skill',
  'skills.workspace.deleteDesc': 'Remove this skill from the library. If any agents still use it, removal will be blocked until it is detached.',
  'skills.workspace.deleteConfirm': 'You are about to remove {name}.',
  'skills.workspace.deleteConfirmGeneric': 'You are about to remove this skill.',
  'skills.workspace.deleteUsedBy': 'Currently used by {agents}.',
  'skills.workspace.deleteBlocked': 'Detach this skill from all agents to enable removal.',
  'skills.workspace.deleteButton': 'Remove skill',
  'skills.workspace.deleting': 'Removing…',

  // Detail header
  'skills.workspace.playground': 'Try Out',
  'skills.workspace.edit': 'Edit',
  'skills.workspace.stopEdit': 'Stop editing',
  'skills.workspace.remove': 'Remove',
  'skills.workspace.sourceLabel': 'Source',
  'skills.workspace.pinLabel': 'Pin',
  'skills.workspace.keyLabel': 'Key',
  'skills.workspace.updatedLabel': 'Updated',
  'skills.workspace.usedByLabel': 'Used by',
  'skills.workspace.untracked': 'untracked',
  'skills.workspace.tracking': 'tracking {ref}',

  // Update
  'skills.workspace.checkUpdates': 'Check for updates',
  'skills.workspace.installUpdate': 'Install update',
  'skills.workspace.upToDate': 'Up to date',
  'skills.workspace.updateSuccess': 'Updated to {ref}',
  'skills.workspace.updateSuccessGeneric': 'Skill updated',
  'skills.workspace.updateFailed': 'Update failed',

  // Restore defaults
  'skills.workspace.restoreDefaults': 'Restore default skills',
  'skills.workspace.restoreSuccess': '{count} default skills restored',
  'skills.workspace.restoreUpToDate': 'Default skills already up to date',
  'skills.workspace.restoreFailed': 'Restore default skills failed',
  'skills.workspace.bundledEditHint': 'System default skills cannot be edited. Duplicate it first to customize.',
  'skills.workspace.bundledDeleteHint': 'System default skills cannot be deleted',

  // Source copy
  'skills.workspace.copySourcePath': 'Copy source path',
  'skills.workspace.copiedSourcePath': 'Copied source path',

  // Toasts
  'skills.workspace.toast.created': 'Skill created',
  'skills.workspace.toast.createFailed': 'Skill creation failed',
  'skills.workspace.toast.saved': 'Skill saved',
  'skills.workspace.toast.saveFailed': 'Save failed',
  'skills.workspace.toast.removed': 'Skill removed',
  'skills.workspace.toast.removeFailed': 'Remove failed',

  // File toolbar
  'skills.workspace.fileView': 'View',
  'skills.workspace.fileCode': 'Code',

  // New skill form
  'skills.workspace.newSkill.namePlaceholder': 'Skill name',
  'skills.workspace.newSkill.slugPlaceholder': 'optional-shortname',
  'skills.workspace.newSkill.descPlaceholder': 'Short description',
  'skills.workspace.newSkill.creating': 'Creating…',
  'skills.workspace.newSkill.createButton': 'Create skill',

  // Source type labels
  'skills.source.github': 'GitHub',
  'skills.source.url': 'URL',
  'skills.source.local': 'Local path',
  'skills.source.database': 'Database',
  'skills.source.githubManaged': 'GitHub managed',
  'skills.source.urlManaged': 'URL managed',
  'skills.source.localManaged': 'Local managed',
  'skills.source.databaseManaged': 'Database managed',
  'skills.source.skillsShManaged': 'skills.sh managed',

  // ── Name translations for system/bundled skills (keyed by skillKey or key) ──
  // When no entry exists, the raw backend name is used as fallback.
  'skills.name.analyze-paper': 'Analyze Paper',
  'skills.name.key-insights': 'Key Insights',
  'skills.name.dense-summary': 'Dense Summary',
  'skills.name.reflection-questions': 'Reflection Questions',
  'skills.name.outline-topics': 'Outline Topics',
  'skills.name.brief-summary': 'Brief Summary',
  'skills.name.summarize-sources': 'Summarize Sources',
  'skills.name.compare-sources': 'Compare Sources',
  'skills.name.extract-evidence': 'Extract Evidence',
  'skills.name.draft-from-sources': 'Draft from Sources',
  'skills.name.extract-action-items': 'Extract Action Items',
  'skills.name.polish-writing': 'Polish Writing',
  'skills.name.build-study-guide': 'Build Study Guide',
  'skills.name.create-quiz': 'Create Quiz',

  // Plugin-prefixed keys (if backend sends e.g. "source-transformations/analyze-paper")
  'skills.name.source-transformations/analyze-paper': 'Analyze Paper',
  'skills.name.source-transformations/key-insights': 'Key Insights',
  'skills.name.source-transformations/dense-summary': 'Dense Summary',
  'skills.name.source-transformations/reflection-questions': 'Reflection Questions',
  'skills.name.source-transformations/outline-topics': 'Outline Topics',
  'skills.name.source-transformations/brief-summary': 'Brief Summary',
  'skills.name.knowledge-research/summarize-sources': 'Summarize Sources',
  'skills.name.knowledge-research/compare-sources': 'Compare Sources',
  'skills.name.knowledge-research/extract-evidence': 'Extract Evidence',
  'skills.name.content-workflow/draft-from-sources': 'Draft from Sources',
  'skills.name.content-workflow/extract-action-items': 'Extract Action Items',
  'skills.name.content-workflow/polish-writing': 'Polish Writing',
  'skills.name.learning-assistant/build-study-guide': 'Build Study Guide',
  'skills.name.learning-assistant/create-quiz': 'Create Quiz',
}

const pluginsPage = {
  // Workspace sidebar
  'plugins.workspace.title': 'Plugins',
  'plugins.availableCount': '{count} available',
  'plugins.filterPlaceholder': 'Filter plugins',
  'plugins.empty': 'No plugins installed. Paste a path to import one.',
  'plugins.emptyTitle': 'No plugin selected',
  'plugins.emptyDesc': 'Select a plugin from the list to view its details, or import a new one.',
  'plugins.noMatch': 'No plugins match this filter.',

  // Import
  'plugins.importPlaceholder': '/absolute/path or https://…/plugin.zip',
  'plugins.inspect': 'Inspect',
  'plugins.inspectFailed': 'Plugin inspection failed',
  'plugins.capabilities': 'Capabilities',
  'plugins.none': 'none',
  'plugins.confirmInstall': 'Confirm install',
  'plugins.installed': 'Plugin installed',
  'plugins.installFailed': 'Plugin installation failed',

  // Review
  'plugins.reviewApprove': 'Review & approve',
  'plugins.reviewApproved': 'Runtime capabilities approved for this exact version',

  // Update
  'plugins.checkUpdate': 'Check update',
  'plugins.upToDate': 'Already up to date',
  'plugins.updateInstalled': 'Update installed; review before enabling',
  'plugins.updateFailed': 'Update failed',

  // Enable/Disable
  'plugins.enable': 'Enable',
  'plugins.disable': 'Disable',
  'plugins.enabled': 'Enabled',
  'plugins.disabled': 'Disabled',

  // Uninstall
  'plugins.uninstall': 'Uninstall',
  'plugins.uninstallTitle': 'Uninstall plugin',
  'plugins.uninstallDesc': 'Remove this plugin from the system. This action cannot be undone.',
  'plugins.uninstallConfirm': 'You are about to uninstall {name}.',
  'plugins.uninstallConfirmGeneric': 'You are about to uninstall this plugin.',
  'plugins.uninstalling': 'Uninstalling…',
  'plugins.uninstalled': 'Plugin uninstalled',
  'plugins.uninstallFailed': 'Plugin uninstall failed',
  'plugins.system': 'System',
  'plugins.systemUninstallHint': 'System plugins cannot be uninstalled',

  // Detail metadata
  'plugins.versionLabel': 'Version',
  'plugins.digestLabel': 'Digest',
  'plugins.digestCopied': 'Digest copied',
  'plugins.copyDigest': 'Copy digest',
  'plugins.statusLabel': 'Status',
  'plugins.stateLabel': 'State',

  // Detail sections
  'plugins.versions': 'Versions',
  'plugins.noVersions': 'No version information',
  'plugins.skills': 'Skills',
  'plugins.noSkills': 'This plugin contains no skills.',
  'plugins.skillTryOut': 'Try Out',
  'plugins.skillDetails': 'Details',
  'plugins.permissions': 'Permissions',
  'plugins.noPermissions': 'No permission information',
  'plugins.hooks': 'Hooks',
  'plugins.noHooks': 'No hook information',

  // Configuration
  'plugins.configuration': 'Configuration',
  'plugins.configJson': 'Configuration JSON',
  'plugins.secretBindings': 'Secret bindings JSON (secret:// references only)',
  'plugins.configSaved': 'Plugin configuration saved',
  'plugins.configError': 'Configuration must be valid JSON and secrets must use secret:// references',
  'plugins.saveConfig': 'Save configuration',

  // ── Name translations for system plugins (keyed by plugin name) ──
  'plugins.name.source-transformations': 'Source Transformations',
  'plugins.name.knowledge-research': 'Knowledge Research',
  'plugins.name.content-workflow': 'Content Workflow',
  'plugins.name.learning-assistant': 'Learning Assistant',
}

const cronPage = {
  'cron.title': 'Cron Jobs',
  'cron.subtitle': 'Manage automated and scheduled tasks for your agents.',
  'cron.status.engine': 'Engine Status',
  'cron.status.enabled': 'Enabled',
  'cron.status.disabled': 'Disabled',
  'cron.status.totalJobs': 'Total Jobs',
  'cron.status.nextWake': 'Next Wake',
  'cron.status.in': 'in {time}',
  'cron.searchPlaceholder': 'Search jobs...',
  'cron.refresh': 'Refresh',
  'cron.newJob': 'New Job',
  'cron.loadError.title': 'Failed to load cron jobs',
  'cron.loadError.description': 'An error occurred while retrieving the cron jobs from the server.',
  'cron.retry': 'Retry',
  'cron.empty.title': 'No cron jobs found.',
  'cron.empty.description': 'Create your first cron job to automate tasks.',
  'cron.empty.search': 'No matching jobs found.',
  'cron.card.untitled': 'Untitled Job',
  'cron.card.schedule.cron': 'Cron: {expr}',
  'cron.card.schedule.every': 'Every {seconds}s',
  'cron.card.schedule.at': 'At {time}',
  'cron.card.schedule.unknown': 'Unknown',
  'cron.card.status.unknown': 'Unknown',
  'cron.card.action.edit': 'Edit Job',
  'cron.card.action.duplicate': 'Duplicate',
  'cron.card.action.delete': 'Delete',
  'cron.card.target': 'Target',
  'cron.card.lastRun': 'Last Run',
  'cron.card.lastRun.never': 'Never',
  'cron.card.nextRun': 'Next Run',
  'cron.form.title.create': 'Create Cron Job',
  'cron.form.title.edit': 'Edit Cron Job',
  'cron.form.description': 'Configure schedule and task payload for this automated agent action',
  'cron.form.tabs.basics': 'Basics & Schedule',
  'cron.form.tabs.execution': 'Execution Target',
  'cron.form.tabs.payload': 'Task Payload',
  'cron.form.name.label': 'Name *',
  'cron.form.name.placeholder': 'e.g. Daily Market Summary',
  'cron.form.desc.label': 'Description',
  'cron.form.desc.placeholder': 'What does this do?',
  'cron.form.enabled': 'Job Enabled',
  'cron.form.schedule.title': 'Schedule Configuration',
  'cron.form.schedule.type': 'Type',
  'cron.form.schedule.type.cron': 'Cron Expression',
  'cron.form.schedule.type.every': 'Interval (Every X ms)',
  'cron.form.schedule.type.at': 'Specific Date/Time',
  'cron.form.schedule.cronExpr': 'Cron Expression',
  'cron.form.schedule.cronExpr.placeholder': '0 8 * * *',
  'cron.form.schedule.everyMs': 'Interval (ms)',
  'cron.form.execution.target': 'Target Session',
  'cron.form.execution.target.main': 'Main (Default Agent)',
  'cron.form.execution.target.isolated': 'Isolated / Background',
  'cron.form.execution.target.current': 'Current UI Session',
  'cron.form.execution.desc': 'Determines which conversation context the background task will interact with.',
  'cron.form.payload.type': 'Payload Type',
  'cron.form.payload.type.agentTurn': 'Agent Turn (Issue Prompt)',
  'cron.form.payload.type.systemEvent': 'System Event (Invisible)',
  'cron.form.payload.text.agentTurn': 'Prompt Text',
  'cron.form.payload.text.systemEvent': 'Event Data',
  'cron.form.payload.placeholder.agentTurn': "e.g. Generate a daily summary of yesterday's alerts...",
  'cron.form.payload.placeholder.systemEvent': 'JSON or plain text...',
  'cron.form.actions.cancel': 'Cancel',
  'cron.form.actions.saving': 'Saving...',
  'cron.form.actions.save': 'Save Job'
}

const agentsPage = {
  'agents.title': 'Agents',
  'agents.tree.title': 'Organization',
  'agents.tree.expand_all': 'Expand All',
  'agents.tree.collapse_all': 'Collapse All',
  'agents.tree.search_placeholder': 'Search agents...',
  'agents.tree.empty': 'No matching agents found',
  'agents.tree.total_agents': '{count} agents total',
  'agents.welcome.title': 'Select an agent to view details',
  'agents.welcome.description': 'Choose an agent from the organization tree on the left to view its dashboard, instructions, configuration, and skills.',
  'agents.welcome.view_ceo_dashboard': 'View {name} Dashboard',
  'agents.detail.not_found': 'Agent Not Found',
  'agents.detail.not_found_desc': 'The requested agent does not exist or has been removed.',
  'agents.detail.back': 'Back to List',
  'agents.detail.back_to_list': 'Back to Agent List',
  'agents.detail.tab.dashboard': 'Dashboard',
  'agents.detail.tab.instructions': 'Instructions',
  'agents.detail.tab.configuration': 'Configuration',
  'agents.detail.tab.skills': 'Skills',
  'agents.dashboard.total_runs': 'Total Runs',
  'agents.dashboard.completed': '{count} completed',
  'agents.dashboard.success_rate': 'Success Rate',
  'agents.dashboard.active_tasks_count': '{count} active tasks',
  'agents.dashboard.avg_response_time': 'Avg Response Time',
  'agents.dashboard.total_cost': 'Total Cost',
  'agents.dashboard.adapter': 'Adapter',
  'agents.dashboard.run_activity': 'Run Activity (14d)',
  'agents.dashboard.success_history': 'Success Rate Trend (7d)',
  'agents.dashboard.recent_runs': 'Recent Runs',
  'agents.dashboard.recent_tasks': 'Recent Tasks',
  'agents.dashboard.cost_breakdown': 'Cost Breakdown',
  'agents.dashboard.input_tokens': 'Input Tokens',
  'agents.dashboard.output_tokens': 'Output Tokens',
  'agents.dashboard.cached_tokens': 'Cached Tokens',
  'agents.instructions.title': 'Agent Instructions',
  'agents.instructions.identity': 'Identity',
  'agents.instructions.name': 'Name',
  'agents.instructions.role': 'Role',
  'agents.instructions.status': 'Status',
  'agents.instructions.reports_to': 'Reports To',
  'agents.instructions.capabilities': 'Capabilities',
  'agents.configuration.adapter_settings': 'Adapter Settings',
  'agents.configuration.adapter_type': 'Adapter Type',
  'agents.configuration.model': 'Model',
  'agents.configuration.temperature': 'Temperature',
  'agents.configuration.max_tokens': 'Max Tokens',
  'agents.configuration.context_window': 'Context Window',
  'agents.configuration.system_prompt': 'System Prompt',
  'agents.configuration.features': 'Features',
}

const creationPromptsVariables = {
  'creation.prompt.var.target_platform': 'Target Platform',
  'creation.prompt.var.output_language': 'Output Language',
  'creation.prompt.var.image_aspect_ratio': 'Aspect Ratio',
  'creation.prompt.var.creation_mode': 'Creation Mode',
  'creation.prompt.var.user_requirements': 'User Requirements',
  'creation.prompt.var.layout_structure': 'Layout Structure',
  'creation.prompt.var.smart_total_count': 'Total Image Count',
  'creation.prompt.var.custom_white_bg': 'White Background',
  'creation.prompt.var.custom_scene': 'Scene Image',
  'creation.prompt.var.custom_selling_point': 'Selling Point',
  'creation.prompt.var.custom_other': 'Other',
  'creation.prompt.var.product_name': 'Product Name',
  'creation.prompt.var.detail_focus': 'Detail Focus',
  'creation.prompt.var.material': 'Material',
  'creation.prompt.var.style': 'Style',
  'creation.prompt.var.ratio': 'Ratio',
  'creation.prompt.var.refine_instruction': 'Refine Instruction',
  'creation.prompt.var.usage': 'Usage',
  'creation.prompt.var.background_instruction': 'Background Instruction',
  'creation.prompt.var.target_resolution': 'Target Resolution',
  'creation.prompt.var.clothing_description': 'Clothing Description',
  'creation.prompt.var.model_description': 'Model Description',
  'creation.prompt.var.scene': 'Scene',
  'creation.prompt.var.pose': 'Pose',
  'creation.prompt.var.set_name': 'Set Name',
  'creation.prompt.var.top_description': 'Top Description',
  'creation.prompt.var.bottom_description': 'Bottom Description',
  'creation.prompt.var.accessories': 'Accessories',
  'creation.prompt.var.views': 'Views',
  'creation.prompt.var.variant_type': 'Variant Type',
  'creation.prompt.var.variant_count': 'Variant Count',
  'creation.prompt.var.variant_descriptions': 'Variant Descriptions',
  'creation.prompt.var.reference_elements': 'Reference Elements',
  'creation.prompt.var.unique_features': 'Unique Features',
  'creation.prompt.var.note_theme': 'Note Theme',
  'creation.prompt.var.vibe': 'Vibe',
  'creation.prompt.var.extra_requirements': 'Extra Requirements',
  'creation.prompt.var.highlights': 'Highlights',
  'creation.prompt.var.camera_movement': 'Camera Movement',
  'creation.prompt.var.bgm_style': 'BGM Style',
  'creation.prompt.var.product_description': 'Product Description',
  'creation.prompt.var.scene_type': 'Scene Type',
  'creation.prompt.var.scene_description': 'Scene Description',
  'creation.prompt.var.atmosphere': 'Atmosphere',
  'creation.prompt.var.topic': 'Topic',
  'creation.prompt.var.description': 'Description',
  'creation.prompt.var.camera_language': 'Camera Language',
  'creation.prompt.var.extra_constraints': 'Extra Constraints',
  'creation.prompt.var.total_duration': 'Total Duration',
  'creation.prompt.var.shot_count': 'Shot Count',
  'creation.prompt.var.storyboard': 'Storyboard',
  'creation.prompt.var.shot_duration': 'Shot Duration',
  'creation.prompt.var.action_summary': 'Action Summary',
  'creation.prompt.var.video_type': 'Video Type',
  'creation.prompt.var.target_duration': 'Target Duration',
  'creation.prompt.var.target_audience': 'Target Audience',
  'creation.prompt.var.key_message': 'Key Message',
  'creation.prompt.var.hook_duration': 'Hook Duration',
  'creation.prompt.var.max_shots': 'Max Shots',
  'creation.prompt.var.target_style': 'Target Style',
  'creation.prompt.var.original_description': 'Original Description',
  'creation.prompt.var.style_reference': 'Style Reference',
  'creation.prompt.var.preserve_elements': 'Preserve Elements',
  'creation.prompt.var.style_strength': 'Style Strength',
  'creation.prompt.var.platform_adaptation': 'Platform Adaptation',
  'creation.prompt.var.gen_type_desc': 'Generation Type Config',
  'creation.prompt.var.gen_total_count': 'Total Image Count Reference',
  'creation.prompt.var.front_back_desc': 'Front/Back Requirements',
  'creation.prompt.var.detail_count': 'Detail Image Count',
  'creation.prompt.var.detail_optimizations': 'Detail Optimizations',
  'creation.prompt.var.detail_ratio': 'Detail Ratio',
  'creation.prompt.var.resolution': 'Resolution',
  'creation.prompt.var.product_count': 'Product Count',
  'creation.prompt.var.reference_count': 'Reference Count',
  'creation.prompt.var.replicate_level': 'Replicate Level',
  'creation.prompt.var.model_details': 'Model Details',
  'creation.prompt.var.refine_optimizations': 'Refine Optimizations',
  'creation.prompt.var.duration': 'Video Duration',
  'creation.prompt.var.enable_voice_text': 'Voiceover',
  'creation.prompt.var.enable_watermark_text': 'Watermark',
  'creation.prompt.var.video_mode_label': 'Video Mode',
  'creation.prompt.var.video_resolution': 'Video Resolution',
  'creation.prompt.var.watermark_text': 'Watermark Text',
  'creation.prompt.numVariables': '{count} variables',
}

const creationPromptsPage = {
  'creation.prompts.page.title': 'Prompt Templates',
  'creation.prompts.page.description': 'Manage prompt templates for all creation scenarios. Upload product images and fill in variable values, then click "Test Generation" to let the multimodal LLM generate complete prompts for each main image.',
  'creation.prompts.page.loading': 'Loading templates...',
  'creation.prompts.page.loadError': 'Failed to load templates',
  'creation.prompts.page.retry': 'Retry',
  'creation.prompts.sidebar.category': 'CATEGORY',
  'creation.prompts.sidebar.templateCategories': 'Template Categories',
  'creation.prompts.sidebar.inheritance': 'Template Inheritance',
  'creation.prompts.sidebar.inheritanceDesc': 'Each category has only one active template. Editing creates a custom version; restoring defaults reverts to the system template.',
  'creation.prompts.list.search': 'Search templates',
  'creation.prompts.list.customized': 'Customized',
  'creation.prompts.list.default': 'System Default',
  'creation.prompts.list.empty': 'No matching templates',
  'creation.prompts.editor.copy': 'Copy Content',
  'creation.prompts.editor.restoring': 'Restoring...',
  'creation.prompts.editor.restore': 'Restore Default',
  'creation.prompts.editor.edit': 'Edit',
  'creation.prompts.editor.editing': 'Editing...',
  'creation.prompts.editor.label': 'Template Content',
  'creation.prompts.editor.placeholder': 'Enter Jinja2 prompt template...',
  'creation.prompts.variables.title': 'Test Variable Values',
  'creation.prompts.variables.selectPlaceholder': 'Select {label}',
  'creation.prompts.variables.inputPlaceholder': 'Enter test value for {label}',
  'creation.prompts.variables.empty': 'This template has no variables.',
  'creation.prompts.functionTool.title': 'Function Calling Schema',
  'creation.prompts.functionTool.description': 'The LLM function calling tool definition for this prompt template. The model is forced to call this tool and return structured output.',
  'creation.prompts.images.title': 'Product Images',
  'creation.prompts.images.description': 'Upload 1-3 product images for LLM vision recognition and main image prompt generation',
  'creation.prompts.images.empty': 'No product images selected',
  'creation.prompts.preview.title': 'Backend Render Preview',
  'creation.prompts.preview.description': 'Validate syntax and replace test variables using the sandbox template engine.',
  'creation.prompts.preview.validating': 'Validating...',
  'creation.prompts.preview.render': 'Render & Validate',
  'creation.prompts.preview.placeholder': 'Fill in test variables and click "Render & Validate".',
  'creation.prompts.warning.title': 'No Multimodal Tools Model Configured',
  'creation.prompts.warning.description': 'The multimodal tools model is the execution engine for function calling. It sends the rendered prompt template + product images to a multimodal LLM to generate structured main image prompts. The model must support both <strong>vision</strong> and <strong>function calling</strong> capabilities.',
  'creation.prompts.warning.goToModels': 'Go to Model Settings',
  'creation.prompts.warning.modelReference': 'Model Recommendations',
  'creation.prompts.generate.title': 'Multimodal LLM Generation',
  'creation.prompts.generate.description': 'Send the rendered prompt template + uploaded product images to a vision LLM, using function calling to generate the title and prompt for each main image.',
  'creation.prompts.generate.generating': 'Generating...',
  'creation.prompts.generate.test': 'Test Generation',
  'creation.prompts.generate.modelUsed': 'Model used:',
  'creation.prompts.generate.mainImage': 'Main Image {idx}: {title}',
  'creation.prompts.generate.copySuccess': 'Prompt for Main Image {idx} copied',
  'creation.prompts.history.title': 'Version History',
  'creation.prompts.history.count': '{count} versions',
  'creation.prompts.history.empty': 'No version history',
  'creation.prompts.meta.category': 'Internal Category',
  'creation.prompts.meta.variables': 'Variable Count',
  'creation.prompts.meta.status': 'Status',
  'creation.prompts.meta.customized': 'Customized',
  'creation.prompts.meta.default': 'System Default',
  'creation.prompts.restoreDialog.title': 'Restore Default Template',
  'creation.prompts.restoreDialog.description': 'Confirm restore to system default template? Current custom content will be overwritten.',
  'creation.prompts.restoreDialog.confirm': 'Restore Default',
  'creation.prompts.recommendations.internationalTitle': 'International Models',
  'creation.prompts.recommendations.internationalDesc': 'The following model series support both multimodal vision understanding and Function Calling, and can be used directly as multimodal tools models.',
  'creation.prompts.recommendations.chineseTitle': 'Chinese Models',
  'creation.prompts.recommendations.chineseDesc': 'The following Chinese model series support both vision understanding and Function Calling.',
  'creation.prompts.recommendations.footer': 'The above information is current as of July 2026. Check official documentation for the latest availability. After configuring, click "Test Generation" to verify the selected model supports both vision and Function Calling.',
  'creation.prompts.toast.saved': 'Template v{version} saved',
  'creation.prompts.toast.saveFailed': 'Save failed; template may have been updated in another window',
  'creation.prompts.toast.validateError': 'Template syntax or variable validation failed',
  'creation.prompts.toast.validatePass': 'Template validation passed',
  'creation.prompts.toast.renderFailed': 'Render failed, check variables and syntax',
  'creation.prompts.toast.restored': 'Restored to system default template',
  'creation.prompts.toast.restoreFailed': 'Failed to restore default template',
  'creation.prompts.toast.selectTemplate': 'Please select a template first',
  'creation.prompts.toast.selectImages': 'Please select at least 1 product image',
  'creation.prompts.toast.generated': 'Generated {count} main image prompts',
  'creation.prompts.toast.noResult': 'Model returned no main image results',
  'creation.prompts.toast.generateFailed': 'Generation failed',
  'creation.prompts.toast.copyContent': 'Template content copied',
  'creation.prompts.group.ecommerce': 'E-Commerce',
  'creation.prompts.group.video': 'Video Generation',
}

const creationPipeline = {
  'pipeline.step.analyze_product': 'Generate Prompts',
  'pipeline.step.generate_images': 'Start Generating Images',
  'pipeline.step.generate_video': 'Generate Video',
  'pipeline.step.generate': 'Main Image #{n}',
  'pipeline.step.collect_results': 'Collect Results',
  'pipeline.step.start': 'Initializing',
  'pipeline.status.pending': 'Pending',
  'pipeline.status.queued': 'Queued',
  'pipeline.status.running': 'Running',
  'pipeline.status.succeeded': 'Completed',
  'pipeline.status.partially_succeeded': 'Partial Success',
  'pipeline.status.failed': 'Failed',
  'pipeline.status.canceled': 'Canceled',
  'pipeline.card.step': 'Step: {step}',
  'pipeline.statusCard.title': 'Progress',
  'pipeline.statusCard.current_step': 'Current step: {step}',
  'pipeline.params.title': 'Task Parameters',
  'pipeline.params.hint': 'Automatically shows the configuration of this run',
  'pipeline.params.empty': 'No parameter info',
  'pipeline.params.prompt': 'Prompt',
  'pipeline.params.platform': 'Platform',
  'pipeline.params.language': 'Language',
  'pipeline.params.mode': 'Mode',
  'pipeline.params.model': 'Model',
  'pipeline.params.main_image_count': 'Main Image Count',
  'pipeline.params.structure_mode': 'Structure Mode',
  'pipeline.params.white_background_count': 'White Background',
  'pipeline.params.scene_image_count': 'Scene Images',
  'pipeline.params.selling_point_count': 'Selling Point Images',
  'pipeline.params.other_image_count': 'Other Images',
  'pipeline.params.aspect_ratio': 'Aspect Ratio',
  'pipeline.params.resolution': 'Resolution',
  'pipeline.params.detail_image_count': 'Detail Image Count',
  'pipeline.params.detail_ratio': 'Detail Ratio',
  'pipeline.params.detail_ratio.aplus_web': 'Enhanced A+ (Web)',
  'pipeline.params.detail_ratio.aplus_mobile': 'Enhanced A+ (Mobile)',
  'pipeline.params.detail_ratio.aplus_standard': 'Standard A+',
  'pipeline.params.detail_ratio.1:1': '1:1',
  'pipeline.params.detail_ratio.3:4': '3:4',
  'pipeline.params.detail_ratio.4:3': '4:3',
  'pipeline.params.detail_ratio.9:16': '9:16',
  'pipeline.params.detail_ratio.16:9': '16:9',
  'pipeline.params.detail_optimization_items': 'Optimization Items',
  'pipeline.params.detail_optimization.hero_visual': 'Hero Visual',
  'pipeline.params.detail_optimization.core_selling_point': 'Core Selling Point',
  'pipeline.params.detail_optimization.usage_scenario': 'Usage Scenario',
  'pipeline.params.detail_optimization.multi_angle': 'Multi-Angle',
  'pipeline.params.detail_optimization.brand_story': 'Brand Story',
  'pipeline.params.detail_optimization.effect_comparison': 'Effect Comparison',
  'pipeline.params.detail_optimization.craftsmanship': 'Craftsmanship',
  'pipeline.params.detail_optimization.size_guide': 'Size Guide',
  'pipeline.params.detail_optimization.specification': 'Specifications',
  'pipeline.params.detail_optimization.accessories': 'Accessories',
  'pipeline.params.detail_optimization.series_showcase': 'Series Showcase',
  'pipeline.params.detail_optimization.ingredients': 'Ingredients',
  'pipeline.params.detail_optimization.after_sales': 'After-Sales',
  'pipeline.params.detail_optimization.usage_tips': 'Usage Tips',
  'pipeline.params.sku_names': 'SKU List',
  'pipeline.params.pairing_mode': 'Pairing Mode',
  'pipeline.params.structure_mode.smart': 'Smart Match',
  'pipeline.params.structure_mode.custom': 'Custom',
  'pipeline.params.product_images': 'Product Images',
  'pipeline.params.reference_images': 'Reference Images',
  'pipeline.params.model_images': 'Model Images',
  'pipeline.params.image_count': '{n} images',
  'pipeline.params.mode.commerce': 'Product Suite',
  'pipeline.params.mode.video': 'Video Replicate',
  'pipeline.params.mode.sku_set': 'SKU Set',
  'pipeline.params.mode.hit_replicate': 'Hit Replicate',
  'pipeline.params.mode.product_refine': 'Product Refine',
  'pipeline.params.mode.clothing_set': 'Clothing Set',
  'pipeline.params.mode.model_wear': 'Model Wear',
  'pipeline.params.video_mode': 'Replicate Mode',
  'pipeline.params.video_resolution': 'Video Resolution',
  'pipeline.params.video_duration': 'Video Duration',
  'pipeline.params.enable_voice': 'Generate Voice',
  'pipeline.params.enable_watermark': 'Add Watermark',
  'pipeline.params.watermark_text': 'Watermark Text',
  'pipeline.params.replicate_level': 'Replicate Level',
  'pipeline.params.refine_optimizations': 'Quick Optimizations',
  'pipeline.params.gen_types': 'Generation Types',
  'pipeline.params.model_source': 'Model Source',
  'pipeline.params.model_gender': 'Model Gender',
  'pipeline.params.model_age': 'Age Group',
  'pipeline.params.model_ethnicity': 'Ethnicity',
  'pipeline.params.model_body_type': 'Body Type',
  'pipeline.params.model_details': 'Details',
  'ecommerce.form.parameterConfig': 'Parameter Configuration',
  'ecommerce.form.parameterHint': 'Configure output specifications based on current needs',
  'ecommerce.form.platform': 'Platform',
  'ecommerce.form.language': 'Language',
  'ecommerce.form.detailCount': 'Detail Image Count',
  'ecommerce.form.detailRatio': 'Detail Ratio',
  'ecommerce.form.structureConfig': 'Structure Configuration',
  'ecommerce.form.structureSmart': 'Smart Match',
  'ecommerce.form.structureCustom': 'Custom',
  'ecommerce.form.structureSmartDesc': 'AI analyzes product images and matches the best listing images',
  'ecommerce.form.structureCustomDesc': 'Freely adjust the count of each image type, select at least 1',
  'ecommerce.form.mainImageCount': 'Main Image Count',
  'ecommerce.form.mainImageCountDesc': 'Set the total number of main images to generate, AI will auto-allocate',
  'ecommerce.form.quickOptimizations': 'Quick Optimizations',
  'ecommerce.form.quickOptimizationsDesc': 'Select common optimization directions, multiple choices allowed',
  'ecommerce.form.productImages': 'Product Images',
  'ecommerce.form.productImagesHint': '1-3 images, recommend including front, side and detail views',
  'ecommerce.form.notSelected': 'No {title} selected',
  'ecommerce.form.count': 'images',
  'ecommerce.form.white_bg': 'White Background',
  'ecommerce.form.white_bgDesc': 'White background main images showing product details from multiple angles',
  'ecommerce.form.scene': 'Scene Image',
  'ecommerce.form.sceneDesc': 'Show product usage scenarios and lifestyle pairings',
  'ecommerce.form.sellingPoint': 'Selling Point',
  'ecommerce.form.sellingPointDesc': 'Showcase core selling points and detail close-ups',
  'ecommerce.form.other': 'Other',
  'ecommerce.form.otherDesc': 'Comparison charts, size guides, etc., intelligently matched based on product',
  'ecommerce.form.currentMode': 'Current Mode',
  'ecommerce.form.reuseSuccess': 'Task parameters and assets reused',
  'ecommerce.form.pointCost': 'Points',
  'ecommerce.form.placeholder.sku': 'SKU {n}',
  'ecommerce.form.placeholder.material': 'Material {n}',
}

const videoDownloader = {
  'vd.sync.title': 'Sync Browser Cookies',
  'vd.sync.description': 'Sync cookies from your logged-in browser sites to the local backend so the video downloader can resolve Douyin / Bilibili / Xiaohongshu / TikTok. yt-dlp will use these cookies automatically.',
  'vd.sync.checking': 'Checking extension...',
  'vd.sync.installed_success': 'Pushed {count} cookies',
  'vd.sync.synced': 'Synced',
  'vd.sync.not_synced': 'Not synced',
  'vd.sync.button': 'Sync All Sites',
  'vd.sync.syncing': 'Syncing...',
  'vd.sync.not_installed_title': 'Cookie Sync extension not installed',
  'vd.sync.not_installed_desc': 'Platforms like Douyin block headless requests. The browser extension reads cookies from your real browser. Follow these steps:',
  'vd.sync.step_1': 'Open chrome://extensions',
  'vd.sync.step_2': 'Enable "Developer mode"',
  'vd.sync.step_3': 'Click "Load unpacked"',
  'vd.sync.step_4': 'Select extensions/fishown-bridge directory',
  'vd.sync.open_ext': 'Open Extensions',
  'vd.sync.retry': "I've installed it, retry",
  'vd.sync.recheck': 'Re-check extension status',
  'vd.sync.no_cookies': 'No cookies found in browser for this site (please log in first)',
  'vd.sync.sync_failed': 'Sync failed',
  'vd.sync.missing_creds': 'No login credentials detected. Please log in to FishOwn first.',
  'vd.sync.pair_title': 'Authorize Browser Extension',
  'vd.sync.pair_desc': 'First-time use requires authorizing the extension on this page. The extension gets restricted permissions (cookie sync, command execution, browser tools only) and never holds your full login credentials. You can revoke it anytime below.',
  'vd.sync.pair_button': 'Authorize Now',
  'vd.sync.pairing': 'Authorizing...',
  'vd.sync.pair_done': 'Authorization successful, extension connected',
  'vd.sync.pair_failed': 'Authorization failed: {error}',
  'vd.sync.paired_title': 'Browser Extension Authorized',
  'vd.sync.manage_title': 'Authorized Extensions',
  'vd.sync.revoke': 'Revoke',
  'vd.sync.revoked': 'Revoked',
  'vd.sync.hint': 'Note: some sites (e.g. Xiaohongshu) require login to read full cookies. Without the extension you can also set VIDEO_DOWNLOADER_COOKIES_FILE to a cookies.txt manually.',
}

const bridgeConnection = {
  'bridge.title': 'Browser Extension Connection',
  'bridge.settings_title': 'Browser Extension',
  'bridge.settings_desc': 'Connect the FishOwn Bridge browser extension for cookie sync, page content sending, and browser automation.',
  'bridge.status_hint': 'Manage browser extension connection',
  'bridge.status_paired': 'Extension connected',
  'bridge.status_not_paired': 'Extension needs authorization',
  'bridge.status_not_installed': 'Extension not installed',
  'bridge.status_checking': 'Checking...',
  'bridge.paired_badge': 'Connected',
  'bridge.local_only_title': 'Browser extension not available here',
  'bridge.local_only_desc': 'The FishOwn Bridge browser extension only works when FishOwn is accessed from localhost. Remote addresses cannot reach the extension — use the desktop app via a local address.',
  'bridge.checking': 'Checking browser extension...',
  'bridge.install_title': 'FishOwn Bridge extension not installed',
  'bridge.install_desc': 'Install the extension, then authorize it on this page to enable cookie sync, page content sending, and browser automation:',
  'bridge.install.step_1': 'Open chrome://extensions',
  'bridge.install.step_2': 'Enable "Developer mode"',
  'bridge.install.step_3': 'Click "Load unpacked"',
  'bridge.install.step_4': 'Select extensions/fishown-bridge directory',
  'bridge.open_ext': 'Open Extensions',
  'bridge.retry': "I've installed it, retry",
  'bridge.recheck': 'Re-check extension status',
  'bridge.pair_title': 'Authorize Browser Extension',
  'bridge.pair_desc': 'First-time use requires authorizing the extension on this page. The extension gets restricted permissions (cookie sync, command execution, browser tools only) and never holds your full login credentials. You can revoke it anytime below.',
  'bridge.pair_button': 'Authorize Now',
  'bridge.pairing': 'Authorizing...',
  'bridge.paired_title': 'Browser extension connected',
  'bridge.open_cookie_sync': 'Sync Browser Cookies',
  'bridge.manage_title': 'Authorized Extensions',
  'bridge.revoke': 'Revoke',
  'bridge.revoked': 'Revoked',
}

const materials = {
  'materials.dir_type.ROOT': 'All',
  'materials.dir_type.SYSTEM': 'System',
  'materials.dir_type.USER': 'User',
  'materials.dir_type.NO_GROUP': 'Uncategorized',
}

export const enTranslations: Record<string, string> = {
  ...navigation,
  ...controls,
  ...user,
  ...settingsLanguage,
  ...settingsActions,
  ...settingsCommon,
  ...settingsContentProcessing,
  ...settingsEmbedding,
  ...settingsFiles,
  ...notebooksPage,
  ...notebooksList,
  ...notebooksCard,
  ...notebooksHeader,
  ...notebooksDetail,
  ...notebooksKnowledgeGraph,
  ...notebooksSources,
  ...notebooksUpload,
  ...notebooksNotes,
  ...notebooksChat,
  ...notebooksEditor,
  ...notebookAssociations,
  ...commonCommandPalette,
  ...commonAddButton,
  ...commonTheme,
  ...commonActions,
  ...commonConfirmDialog,
  ...commonErrorBoundary,
  ...commonConnection,
  ...commonModelSelector,
  ...modelSelectorDialog,
  ...commonContextToggle,
  ...commonContextIndicator,
  ...searchPage,
  ...sourcesPage,
  ...auth,
  ...bananaproPage,
  ...imageGeneratorPage,
  ...videoGeneratorPage,
  ...addSourceDialog,
  ...addExistingSourceDialog,
  ...createNotebookDialog,
  ...collapsibleColumn,
  ...modelsPage,
  ...providerStatus,
  ...providerSettings,
  ...modelTypeSection,
  ...modelPricing,
  ...defaultModelsSection,
  ...addModelForm,
  ...embeddingModelChangeDialog,
  ...digitalEmployeesPage,
  ...marketplacePage,
  ...workflowsPage,
  ...advancedPage,
  ...sourceCard,
  ...sourceDetail,
  ...streamingResponse,
  ...advancedModelsDialog,
  ...saveToNotebooksDialog,
  ...modelsToast,
  ...xhsqunToast,
  ...dykolToast,
  ...xhsqunPrivateToast,
  ...emailTemplateToast,
  ...emailRenewToast,
  ...gnkeyToast,
  ...emailCustomerToast,
  ...emailTaskToast,
  ...workflowsToast,
  ...gzhkolMonitorToast,
  ...gzhkolResourceToast,
  ...dykolTask,
  ...notebooksToast,
  ...emailTaskPage,
  ...notesToast,
  ...searchToast,
  ...settingsToast,
  ...sourcesToast,
  ...versionCheckToast,
  ...chatToast,
  ...commonToast,
  ...skillsPage,
  ...pluginsPage,
  ...cronPage,
  ...agentsPage,
  ...creationPromptsPage,
  ...creationPromptsVariables,
  ...creationPipeline,
  ...videoDownloader,
  ...bridgeConnection,
  ...materials,
}
